"use strict";
(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/quiz"],{

/***/ "./src/assets/js/quiz-components/custom-dropdown.js":
/*!**********************************************************!*\
  !*** ./src/assets/js/quiz-components/custom-dropdown.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomDropdown = /*#__PURE__*/function (_HTMLElement) {
  function CustomDropdown() {
    var _this$breedSearchDrop, _this$breedSearchDrop2, _this$select;
    var _this;
    _classCallCheck(this, CustomDropdown);
    _this = _callSuper(this, CustomDropdown);
    _this.quizContainer = _this.closest('quiz-container');
    _this.breedSearchDropdown = _this.querySelector('.breed-dropdown');
    _this.inputText = _this.querySelector('.breed-dropdown__wrapper__text');
    _this.dropdownList = _this.querySelector('.breed-dropdown__list');
    _this.inputId = ((_this$breedSearchDrop = _this.breedSearchDropdown) === null || _this$breedSearchDrop === void 0 ? void 0 : _this$breedSearchDrop.getAttribute('data-id')) || '';
    _this.breedsData = window['breedSearchData' + _this.inputId];
    _this.dropdownBreedItem = _this.querySelector('.breed-dropdown-item');
    _this.breedInner = _this.querySelector('.breed-dropdown__wrapper-inner');
    _this.breedWrapper = _this.querySelector('.breed-dropdown__wrapper');
    _this.nothingText = ((_this$breedSearchDrop2 = _this.breedSearchDropdown) === null || _this$breedSearchDrop2 === void 0 ? void 0 : _this$breedSearchDrop2.getAttribute('data-nothing-text')) || 'Nothing found';
    _this.dropdownVisible = false;
    _this.select = _this.querySelector('.select');
    _this.selectElements = (_this$select = _this.select) === null || _this$select === void 0 ? void 0 : _this$select.querySelectorAll('option');
    _this.type = _this.dataset.type;
    _this.entry = _this.dataset.entry;
    _this.isSelectForRange = _this.dataset.type === 'select-for-range';
    return _this;
  }
  _inherits(CustomDropdown, _HTMLElement);
  return _createClass(CustomDropdown, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.isSelectForRange) {
        this.initSelectForRange();
      } else {
        this.initBreedDropdown();
      }
      this.assignEventListeners();
      this.restoreState();
    }
  }, {
    key: "initSelectForRange",
    value: function initSelectForRange() {
      if (this.select) {
        this.select.addEventListener('change', this.handleSelectChange.bind(this));
      }
    }
  }, {
    key: "initBreedDropdown",
    value: function initBreedDropdown() {
      var _this2 = this;
      if (this.breedsData) {
        var allBreeds = _toConsumableArray(new Set(this.breedsData.flatMap(function (data) {
          return data.breedList;
        }))).sort();
        var dropdownAddHTML = allBreeds.map(function (breed) {
          if (breed !== null) {
            return "<div class=\"breed-dropdown-item\" data-breed=\"".concat(breed, "\">").concat(breed, "</div>");
          }
          return '';
        }).join('');
        this.dropdownList.innerHTML = dropdownAddHTML;
        this.dropdownList.querySelectorAll('.breed-dropdown-item').forEach(function (item) {
          item.addEventListener('click', _this2.selectBreed.bind(_this2));
          item.addEventListener('mousedown', function (e) {
            return e.preventDefault();
          });
        });
      }
    }
  }, {
    key: "assignEventListeners",
    value: function assignEventListeners() {
      var _this3 = this;
      if (this.isSelectForRange) {
        var _this$select2;
        (_this$select2 = this.select) === null || _this$select2 === void 0 || _this$select2.addEventListener('change', this.handleSelectChange.bind(this));
      } else {
        var _this$inputText, _this$inputText2, _this$inputText3;
        (_this$inputText = this.inputText) === null || _this$inputText === void 0 || _this$inputText.addEventListener('focus', function () {
          _this3.dropdownVisible = true;
          _this3.dropdownList.classList.add('active');
          _this3.breedInner.classList.add('active');
        });
        document.addEventListener('click', function (event) {
          if (!event.target.closest('.breed-dropdown__wrapper') && _this3.dropdownVisible) {
            _this3.dropdownVisible = false;
            _this3.dropdownList.classList.remove('active');
            _this3.breedInner.classList.remove('active');
            _this3.quizContainer.validateInputs();
            _this3.saveState(_this3.inputText.value);
          }
        });
        (_this$inputText2 = this.inputText) === null || _this$inputText2 === void 0 || _this$inputText2.addEventListener('change', function () {
          _this3.quizContainer.validateInputs();
          _this3.saveState(_this3.inputText.value);
        });
        (_this$inputText3 = this.inputText) === null || _this$inputText3 === void 0 || _this$inputText3.addEventListener('input', function (event) {
          _this3.quizContainer.validateInputs();
          _this3.saveState(_this3.inputText.value);
          _this3.filterBreeds(event);
        });
      }
    }
  }, {
    key: "handleSelectChange",
    value: function handleSelectChange(event) {
      var _this$quizContainer, _document$querySelect;
      var selectedValue = event.target.value;
      this.saveState(selectedValue);
      this.updateRangeInput(selectedValue);
      (_this$quizContainer = this.quizContainer) === null || _this$quizContainer === void 0 || _this$quizContainer.validateInputs();
      (_document$querySelect = document.querySelector('quiz-container')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.activeSlider) === null || _document$querySelect === void 0 || _document$querySelect.update();
    }
  }, {
    key: "updateRangeInput",
    value: function updateRangeInput(value) {
      var rangeInput = this.closest('.swiper-slide').querySelector('custom-input-range');
      if (rangeInput && rangeInput.sliderInstance) {
        var index = Array.from(this.select.options).findIndex(function (option) {
          return option.value === value;
        });
        rangeInput.sliderInstance.set(index);
      }
    }
  }, {
    key: "saveState",
    value: function saveState(value) {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (!quizData.dropdownStates) {
        quizData.dropdownStates = {};
      }
      quizData.dropdownStates[this.entry] = value;
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }
  }, {
    key: "restoreState",
    value: function restoreState() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData.dropdownStates && quizData.dropdownStates[this.entry]) {
        var savedValue = quizData.dropdownStates[this.entry];
        if (this.isSelectForRange && this.select) {
          this.select.value = savedValue;
          this.updateRangeInput(savedValue);
        } else if (this.inputText) {
          this.inputText.value = savedValue;
        }
      }
    }
  }, {
    key: "selectBreed",
    value: function selectBreed(event) {
      event.preventDefault();
      event.stopPropagation();
      var breed = event.target.dataset.breed;
      this.inputText.value = breed;
      this.saveState(breed);
      this.dropdownVisible = false;
      this.dropdownList.classList.remove('active');
      this.breedInner.classList.remove('active');
      this.quizContainer.validateInputs();
    }
  }, {
    key: "filterBreeds",
    value: function filterBreeds(event) {
      var searchTerm = event.target.value.toLowerCase();
      var found = 0;
      this.dropdownList.querySelectorAll('.breed-dropdown-item').forEach(function (item) {
        var breed = item.dataset.breed.toLowerCase();
        if (breed.includes(searchTerm)) {
          found++;
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
      this.dropdownList.style.height = found > 4 ? '180px' : 'auto';
      if (found === 0) {
        this.showNothingFound();
      } else {
        this.hideNothingFound();
      }
    }
  }, {
    key: "showNothingFound",
    value: function showNothingFound() {
      var existingMessage = this.dropdownList.querySelector('.found-nothing');
      if (existingMessage) {
        existingMessage.remove();
      }
      var messageEl = document.createElement('div');
      messageEl.classList.add('found-nothing');
      messageEl.textContent = this.nothingText;
      this.dropdownList.appendChild(messageEl);
      messageEl.addEventListener('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    }
  }, {
    key: "hideNothingFound",
    value: function hideNothingFound() {
      var message = this.dropdownList.querySelector('.found-nothing');
      if (message) {
        message.remove();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomDropdown);

/***/ }),

/***/ "./src/assets/js/quiz-components/custom-form.js":
/*!******************************************************!*\
  !*** ./src/assets/js/quiz-components/custom-form.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomForm = /*#__PURE__*/function (_HTMLElement) {
  function CustomForm() {
    var _this;
    _classCallCheck(this, CustomForm);
    _this = _callSuper(this, CustomForm);
    _this.quizContainer = _this.closest('quiz-container');
    _this.entry = _this.dataset.entry;
    _this.inputName = _this.querySelector('.custom-form__text');
    _this.inputEmail = _this.querySelector('.custom-form__email');
    _this.checkbox = _this.querySelector('input[type="checkbox"]');
    _this.nameEntry = _this.entry;
    _this.emailEntry = 'entry.777824080';
    _this.checkBoxEntry = 'entry.18131054';
    return _this;
  }
  _inherits(CustomForm, _HTMLElement);
  return _createClass(CustomForm, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      var inputEventHandlers = function inputEventHandlers() {
        _this2.quizContainer.validateInputs();
        _this2.saveInputValues();
      };
      this.inputName.addEventListener('input', inputEventHandlers);
      this.inputName.addEventListener('change', inputEventHandlers);
      this.inputName.addEventListener('blur', inputEventHandlers);
      this.inputEmail.addEventListener('input', inputEventHandlers);
      this.inputEmail.addEventListener('change', inputEventHandlers);
      this.inputEmail.addEventListener('blur', inputEventHandlers);
      this.checkbox.addEventListener('change', inputEventHandlers);
    }
  }, {
    key: "saveInputValues",
    value: function saveInputValues() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {
        inputs: {}
      };
      var inputs = quizData.inputs;
      inputs[this.inputName.id] = {
        value: this.inputName.value,
        entry: this.nameEntry
      };
      inputs[this.inputEmail.id] = {
        value: this.inputEmail.value,
        entry: this.emailEntry
      };
      inputs[this.checkbox.id] = {
        value: this.querySelector('input[type="checkbox"]').checked,
        entry: this.checkBoxEntry
      };
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }
  }, {
    key: "restoreInputValue",
    value: function restoreInputValue(inputElement) {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {
        inputs: {}
      };
      var inputId = inputElement.id;
      if (quizData.inputs && quizData.inputs[inputId]) {
        var inputData = quizData.inputs[inputId];
        inputElement.value = inputData.value;
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.setEventListeners();
      this.restoreInputValue(this.inputName);
      this.restoreInputValue(this.inputEmail);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomForm);

/***/ }),

/***/ "./src/assets/js/quiz-components/custom-input-checkbox.js":
/*!****************************************************************!*\
  !*** ./src/assets/js/quiz-components/custom-input-checkbox.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomInputCheckbox = /*#__PURE__*/function (_HTMLElement) {
  function CustomInputCheckbox() {
    var _this;
    _classCallCheck(this, CustomInputCheckbox);
    _this = _callSuper(this, CustomInputCheckbox);
    _this.quizContainer = _this.closest('quiz-container');
    _this.entry = _this.dataset.entry;
    _this.inputs = _this.querySelectorAll('input[type="checkbox"]');
    _this.closestStep = _this.closest('.swiper-slide--step');
    _this.hasBottomDesc = _this.dataset.bottomdesc ? true : false;
    _this.quizFooter = _this.quizContainer.querySelector('quiz-footer');
    _this.labels = _this.querySelectorAll('label');
    _this.limitChoice = _this.dataset.limit ? parseInt(_this.dataset.limit) : null;
    return _this;
  }
  _inherits(CustomInputCheckbox, _HTMLElement);
  return _createClass(CustomInputCheckbox, [{
    key: "saveCheckboxState",
    value: function saveCheckboxState() {
      var state = Array.from(this.inputs).map(function (input) {
        return {
          id: input.id,
          checked: input.checked,
          value: input.value,
          textValue: input.getAttribute('data-textvalue'),
          // Save data-textvalue
          img: input.getAttribute('data-image-src')
        };
      });
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      quizData.checkboxStates = quizData.checkboxStates || {};
      quizData.checkboxStates[this.entry] = state;
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }
  }, {
    key: "restoreCheckboxState",
    value: function restoreCheckboxState() {
      var _this2 = this;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var state = quizData.checkboxStates && quizData.checkboxStates[this.entry];
      if (state) {
        state.forEach(function (_ref) {
          var id = _ref.id,
            checked = _ref.checked;
          var input = _this2.querySelector("input[type=\"checkbox\"]#".concat(id));
          if (input) {
            input.checked = checked;
          }
        });
      }
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this3 = this;
      this.inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          var checkedInputs = Array.from(_this3.inputs).filter(function (i) {
            return i.checked;
          }).length;
          if (_this3.limitChoice !== null && checkedInputs > _this3.limitChoice) {
            // If limit is exceeded, uncheck the last checked input and return
            var message = window.quizLocales.errors.limits.replace('{{limit}}', _this3.limitChoice);
            alert(message);
            input.checked = false; // Prevent the new selection
            return;
          }
          _this3.saveCheckboxState();
          if (_this3.quizContainer && typeof _this3.quizContainer.validateInputs === 'function') {
            _this3.quizContainer.validateInputs();
          }
        });
      });
      if (this.hasBottomDesc) {
        this.labels.forEach(function (label) {
          label.addEventListener('click', function () {
            // previous element
            var closestInput = label.previousElementSibling;
            setTimeout(function () {
              if (closestInput.checked) {
                _this3.quizFooter.updateBoth(label.dataset.labelvalue, label.dataset.labeltext);
              } else {
                var defaultTitle = _this3.closestStep.dataset.title;
                var defaultText = _this3.quizContainer.returnExtractedText(_this3.quizContainer.activeSlider.activeIndex);
                _this3.quizFooter.updateBoth(defaultTitle, defaultText);
              }
            }, 200);
          });
        });
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.restoreCheckboxState();
      this.setEventListeners();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomInputCheckbox);

/***/ }),

/***/ "./src/assets/js/quiz-components/custom-input-number.js":
/*!**************************************************************!*\
  !*** ./src/assets/js/quiz-components/custom-input-number.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomInputNumber = /*#__PURE__*/function (_HTMLElement) {
  function CustomInputNumber() {
    var _this;
    _classCallCheck(this, CustomInputNumber);
    _this = _callSuper(this, CustomInputNumber);
    _this.input = _this.querySelector('input');
    _this.quizContainer = _this.closest('quiz-container');
    _this.entry = _this.dataset.entry;
    _this.wetFood = _this.dataset.wetfood ? true : false;
    return _this;
  }
  _inherits(CustomInputNumber, _HTMLElement);
  return _createClass(CustomInputNumber, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.input.oninput = function () {
        _this2.quizContainer.validateInputs();
        _this2.saveInputValue();
      };
      this.input.addEventListener('input', function () {
        _this2.quizContainer.validateInputs();
        _this2.validateCurrentInput();
        _this2.saveInputValue();
      });
      this.input.addEventListener('change', function () {
        _this2.quizContainer.validateInputs();
        _this2.saveInputValue();
      });
      this.input.addEventListener('blur', function () {
        _this2.quizContainer.validateInputs();
        _this2.saveInputValue();
      });
    }
  }, {
    key: "saveInputValue",
    value: function saveInputValue() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (!quizData.inputs) {
        quizData.inputs = {};
      }
      quizData.inputs[this.input.id] = {
        value: this.input.value,
        entry: this.entry
      };
      localStorage.setItem('quiz', JSON.stringify(quizData));
      ;
    }
  }, {
    key: "restoreInputValue",
    value: function restoreInputValue() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData && quizData.inputs && quizData.inputs[this.input.id]) {
        var inputData = quizData.inputs[this.input.id];
        this.input.value = inputData.value;
      }
    }
  }, {
    key: "validateCurrentInput",
    value: function validateCurrentInput() {
      var value = this.input.value;
      var min = this.input.getAttribute("min");
      var max = this.input.getAttribute("max");
      if (min && +value < +min) {
        this.input.value = min;
      }
      if (max && +value > +max) {
        this.input.value = max;
      }
    }
  }, {
    key: "checkWetFood",
    value: function checkWetFood() {
      var wetFoodCheckbox = this.closest('quiz-container').querySelector('#nassfutter');
      var dryFoodCheckbox = this.closest('quiz-container').querySelector('#trockenfutter');
      this.validateCurrentInput();
      if (wetFoodCheckbox.checked && dryFoodCheckbox.checked) {
        var _document$querySelect;
        this.classList.remove('tw-hidden');
        (_document$querySelect = document.querySelector('quiz-container')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.activeSlider) === null || _document$querySelect === void 0 || _document$querySelect.update();
      } else {
        var _document$querySelect2;
        this.classList.add('tw-hidden');
        if (wetFoodCheckbox.checked == false && dryFoodCheckbox.checked == true) {
          this.input.value = 100;
        } else {
          this.input.value = 0;
        }
        this.saveInputValue();
        this.quizContainer.validateInputs();
        (_document$querySelect2 = document.querySelector('quiz-container')) === null || _document$querySelect2 === void 0 || (_document$querySelect2 = _document$querySelect2.activeSlider) === null || _document$querySelect2 === void 0 || _document$querySelect2.update();
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      this.setEventListeners();
      this.restoreInputValue();
      if (this.wetFood) {
        setInterval(function () {
          _this3.checkWetFood();
        }, 1000);
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomInputNumber);

/***/ }),

/***/ "./src/assets/js/quiz-components/custom-input-radio.js":
/*!*************************************************************!*\
  !*** ./src/assets/js/quiz-components/custom-input-radio.js ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomInputRadio = /*#__PURE__*/function (_HTMLElement) {
  function CustomInputRadio() {
    var _this;
    _classCallCheck(this, CustomInputRadio);
    _this = _callSuper(this, CustomInputRadio);
    _this.quizContainer = _this.closest('quiz-container');
    _this.entry = _this.dataset.entry;
    _this.inputs = _this.querySelectorAll('input[type="radio"]');
    _this.radioLabels = _this.querySelectorAll('.custom-label-radio__with-img');
    return _this;
  }
  _inherits(CustomInputRadio, _HTMLElement);
  return _createClass(CustomInputRadio, [{
    key: "saveRadioState",
    value: function saveRadioState() {
      var _Array$from$find;
      var selected = (_Array$from$find = Array.from(this.inputs).find(function (input) {
        return input.checked;
      })) === null || _Array$from$find === void 0 ? void 0 : _Array$from$find.value;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (!quizData.radioStates) {
        quizData.radioStates = {};
      }
      quizData.radioStates[this.entry] = selected;
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }
  }, {
    key: "restoreRadioState",
    value: function restoreRadioState() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData && quizData.radioStates && quizData.radioStates[this.entry]) {
        var selectedValue = quizData.radioStates[this.entry];
        var toCheck = Array.from(this.inputs).find(function (input) {
          return input.value === selectedValue;
        });
        if (toCheck) {
          toCheck.checked = true;
        }
      } else {
        this.saveRadioState();
      }
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.inputs.forEach(function (input) {
        input.addEventListener('input', function () {
          _this2.saveRadioState();
          if (_this2.quizContainer && typeof _this2.quizContainer.validateInputs === 'function') {
            _this2.quizContainer.validateInputs();
          }
        });
      });
      this.radioLabels.forEach(function (label) {
        label.addEventListener('click', function () {
          var radioInput = label.previousElementSibling;
          if (radioInput && radioInput.type === 'radio') {
            radioInput.checked = true;
            _this2.saveRadioState();
          }
        });
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.restoreRadioState();
      this.setEventListeners();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomInputRadio);

/***/ }),

/***/ "./src/assets/js/quiz-components/custom-input-range.js":
/*!*************************************************************!*\
  !*** ./src/assets/js/quiz-components/custom-input-range.js ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomInputRange = /*#__PURE__*/function (_HTMLElement) {
  function CustomInputRange() {
    var _this;
    _classCallCheck(this, CustomInputRange);
    _this = _callSuper(this, CustomInputRange);
    _this.sliderStep = _this.querySelector('.slider-step');
    _this.sliderValue = _this.querySelector('.slider-step-value');
    _this.quizContainer = _this.closest('quiz-container');
    _this.entry = _this.dataset.entry;
    var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
    _this.value = quizData.rangeValues && quizData.rangeValues[_this.entry] !== undefined ? quizData.rangeValues[_this.entry] : 1;
    _this.textValues = _this.querySelectorAll('.text');
    _this.valueSize = _this.textValues.length;
    return _this;
  }
  _inherits(CustomInputRange, _HTMLElement);
  return _createClass(CustomInputRange, [{
    key: "slider",
    value: function slider() {
      if (this.value == 'NaN') {
        this.value = 1;
      }
      var needed_value = 1;
      if (this.value != 'NaN') {
        needed_value = this.value;
      }
      this.sliderInstance = noUiSlider.create(this.sliderStep, {
        start: [needed_value],
        step: 1,
        range: {
          'min': [0],
          'max': [this.valueSize - 1]
        }
      });
    }
  }, {
    key: "saveRangeValue",
    value: function saveRangeValue() {
      var currentValue = +this.querySelector(".noUi-handle").getAttribute('aria-valuetext');
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (currentValue == 'NaN') {
        currentValue = 1;
      }
      if (!quizData.rangeValues) {
        quizData.rangeValues = {};
      }
      quizData.rangeValues[this.entry] = currentValue;
      localStorage.setItem('quiz', JSON.stringify(quizData));
      this.quizContainer.enableNextBtn();
    }
  }, {
    key: "updateImage",
    value: function updateImage() {
      var dateStepInput = this.closest('date-step-input');
      dateStepInput.querySelectorAll('.image-with-text').forEach(function (ageimage) {
        ageimage.classList.add('tw-hidden');
      });
      if (this.value < 2) {
        dateStepInput.querySelectorAll('.image-with-text')[0].classList.remove('tw-hidden');
      } else if (this.value > 1 && this.value < 7) {
        dateStepInput.querySelectorAll('.image-with-text')[1].classList.remove('tw-hidden');
      } else {
        dateStepInput.querySelectorAll('.image-with-text')[2].classList.remove('tw-hidden');
      }
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.sliderStep.noUiSlider.on('update', function (values, handle) {
        _this2.value = values[handle];
        _this2.saveRangeValue();
        var int_value = parseInt(_this2.value);
        _this2.textValues.forEach(function (text) {
          return text.classList.remove('active');
        });
        if (_this2.textValues[int_value]) {
          _this2.textValues[int_value].classList.add('active');
        }
        _this2.quizContainer.validateInputs();
        if (_this2.closest('date-step-input')) {
          _this2.updateImage();
        }
      });
    }
  }, {
    key: "restoreRangeValue",
    value: function restoreRangeValue() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData && quizData.rangeValues && quizData.rangeValues[this.entry] !== undefined) {
        this.dataset.valuesize = quizData.rangeValues[this.entry];
        var savedValue = quizData.rangeValues[this.entry];
        if (savedValue == 'NaN') {
          savedValue = 1;
        }
        this.sliderInstance.set(savedValue);
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      var checkSlider = setInterval(function () {
        if (typeof noUiSlider !== 'undefined') {
          _this3.slider();
          _this3.setEventListeners();
          _this3.restoreRangeValue();
          clearInterval(checkSlider);
        }
      }, 100);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomInputRange);

/***/ }),

/***/ "./src/assets/js/quiz-components/custom-input-text.js":
/*!************************************************************!*\
  !*** ./src/assets/js/quiz-components/custom-input-text.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomInpuText = /*#__PURE__*/function (_HTMLElement) {
  function CustomInpuText() {
    var _this;
    _classCallCheck(this, CustomInpuText);
    _this = _callSuper(this, CustomInpuText);
    _this.input = _this.querySelector('input');
    _this.quizContainer = _this.closest('quiz-container');
    _this.entry = _this.dataset.entry;
    return _this;
  }
  _inherits(CustomInpuText, _HTMLElement);
  return _createClass(CustomInpuText, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.input.oninput = function () {
        _this2.quizContainer.validateInputs();
        _this2.saveInputValue();
      };
      this.input.addEventListener('change', function () {
        _this2.quizContainer.validateInputs();
        _this2.saveInputValue();
      });
      this.input.addEventListener('blur', function () {
        _this2.quizContainer.validateInputs();
        _this2.saveInputValue();
      });
    }
  }, {
    key: "saveInputValue",
    value: function saveInputValue() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (!quizData.inputs) {
        quizData.inputs = {};
      }
      quizData.inputs[this.input.id] = {
        value: this.input.value,
        entry: this.entry
      };
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }
  }, {
    key: "restoreInputValue",
    value: function restoreInputValue() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData && quizData.inputs && quizData.inputs[this.input.id]) {
        var inputData = quizData.inputs[this.input.id];
        this.input.value = inputData.value;
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.setEventListeners();
      this.restoreInputValue();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomInpuText);

/***/ }),

/***/ "./src/assets/js/quiz-components/custom-product-loader.js":
/*!****************************************************************!*\
  !*** ./src/assets/js/quiz-components/custom-product-loader.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomProductLoader = /*#__PURE__*/function (_HTMLElement) {
  function CustomProductLoader() {
    var _this;
    _classCallCheck(this, CustomProductLoader);
    _this = _callSuper(this, CustomProductLoader);
    _this.target = _this.getAttribute('data-target');
    _this.init();
    return _this;
  }
  _inherits(CustomProductLoader, _HTMLElement);
  return _createClass(CustomProductLoader, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.checkCheckboxes();
              document.addEventListener('sliderChange', function () {
                _this2.checkCheckboxes();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "saveHandleToCartAttributes",
    value: function () {
      var _saveHandleToCartAttributes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(handle) {
        var response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  attributes: {
                    'quiz_product_handle': handle
                  }
                })
              });
            case 1:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 2;
                break;
              }
              throw new Error('Failed to update cart attributes');
            case 2:
              console.log('Product handle saved to cart attributes:', handle);
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.error('Error saving handle to cart attributes:', _t);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 3]]);
      }));
      function saveHandleToCartAttributes(_x) {
        return _saveHandleToCartAttributes.apply(this, arguments);
      }
      return saveHandleToCartAttributes;
    }()
  }, {
    key: "setSlideChangeEventListener",
    value: function setSlideChangeEventListener() {
      var _this3 = this;
      document.addEventListener('slideChange', function () {
        _this3.isActiveSlide = !!_this3.closest('.swiper-slide-active');
        console.log('slideChange', _this3.isActiveSlide);
        if (_this3.isActiveSlide) {
          setTimeout(function () {
            _this3.init();
          }, 400);
        }
      });
    }
  }, {
    key: "checkCheckboxes",
    value: function checkCheckboxes() {
      this.classList.add('loading');
      var checkboxes = document.querySelectorAll('custom-input-checkbox[data-entry="entry.306846565"] input[type="checkbox"]');
      var selectedValues = [];
      checkboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
          selectedValues.push(checkbox.value);
        }
      });
      if (selectedValues.length > 0) {
        this.searchForProduct(selectedValues);
      }
    }
  }, {
    key: "searchForProduct",
    value: function () {
      var _searchForProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(selectedValues) {
        var breed, productHandle;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              breed = this.getBreed();
              console.log('Breed:', breed);
              console.log('Selected values:', selectedValues);
              productHandle = this.findMatchingProduct(selectedValues, breed);
              if (!productHandle) {
                productHandle = this.findFallbackProduct(selectedValues);
              }
              if (!productHandle) {
                _context3.n = 3;
                break;
              }
              _context3.n = 1;
              return this.saveHandleToCartAttributes(productHandle);
            case 1:
              _context3.n = 2;
              return this.loadProduct(productHandle);
            case 2:
              _context3.n = 4;
              break;
            case 3:
              console.log('No matching product found');
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function searchForProduct(_x2) {
        return _searchForProduct.apply(this, arguments);
      }
      return searchForProduct;
    }()
  }, {
    key: "getBreed",
    value: function getBreed() {
      var _answers$dropdownStat;
      var answers = JSON.parse(localStorage.getItem('quiz')) || {};
      return ((_answers$dropdownStat = answers.dropdownStates) === null || _answers$dropdownStat === void 0 ? void 0 : _answers$dropdownStat["entry.62437307"]) || "Unknown";
    }
  }, {
    key: "findMatchingProduct",
    value: function findMatchingProduct(selectedValues, breed) {
      var products = window.all_products;

      // First, try to find an exact match for type and breed
      var _iterator = _createForOfIteratorHelper(products),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var product = _step.value;
          if (product.breeds.some(function (b) {
            return b.breedList.includes(breed);
          }) && this.matchProductType(product, selectedValues)) {
            console.log('Matching product found:', product.handle);
            return product.handle;
          }
        }

        // If no exact match, try fallback by breed and fallback type
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(products),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _product = _step2.value;
          if (_product.breeds.some(function (b) {
            return b.breedList.includes(breed);
          }) && this.matchFallbackType(_product.fallback_type, selectedValues)) {
            console.log('Matching fallback product found:', _product.handle);
            return _product.handle;
          }
        }

        // If still no match, try fallback by type only
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(products),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _product2 = _step3.value;
          if (this.matchFallbackType(_product2.fallback_type, selectedValues)) {
            console.log('Fallback product found:', _product2.handle);
            return _product2.handle;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      console.log('No matching product found');
      return null;
    }
  }, {
    key: "findFallbackProduct",
    value: function findFallbackProduct(selectedValues) {
      var products = window.all_products;

      // First, try fallback by breed and fallback type
      var _iterator4 = _createForOfIteratorHelper(products),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var product = _step4.value;
          if (this.matchFallbackType(product.fallback_type, selectedValues)) {
            console.log('Fallback product found:', product.handle);
            return product.handle;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      console.log('No fallback product found');
      return null;
    }
  }, {
    key: "matchProductType",
    value: function matchProductType(product, selectedValues) {
      var productTypes = [];
      if (product.type && product.type.includes(',')) {
        productTypes = product.type.split(', ');
      } else if (product.type) {
        productTypes = [product.type];
      }
      if (productTypes.length === 0 && product.fallback_type) {
        return this.matchFallbackType(product.fallback_type, selectedValues);
      }
      return selectedValues.every(function (value) {
        return productTypes.includes(value);
      }) || selectedValues.includes('Nassfutter') && (productTypes.includes('Barf Futter') || productTypes.includes('Selbstgekocht'));
    }
  }, {
    key: "matchFallbackType",
    value: function matchFallbackType(fallbackType, selectedValues) {
      if (selectedValues.includes(fallbackType)) {
        console.log('Matched fallback type:', fallbackType);
        return true;
      }
      if ((fallbackType === 'Barf Futter' || fallbackType === 'Selbstgekocht') && selectedValues.includes('Nassfutter')) {
        console.log('Matched fallback type:', fallbackType);
        return true;
      }
      console.log('No match for fallback type:', fallbackType);
      return false;
    }
  }, {
    key: "loadProduct",
    value: function () {
      var _loadProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(productHandle) {
        var response, html, parser, doc, productOutput;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return fetch("".concat(window.location.href, "?product=").concat(productHandle));
            case 1:
              response = _context4.v;
              _context4.n = 2;
              return response.text();
            case 2:
              html = _context4.v;
              parser = new DOMParser();
              doc = parser.parseFromString(html, 'text/html');
              productOutput = doc.querySelector(this.target);
              if (productOutput) {
                this.replaceLoaderWithProduct(productOutput);
                this.replaceBreedName();
                this.replaceDogName();
                this.classList.remove('loading');
              } else {
                console.log('Product output not found in the fetched HTML');
              }
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function loadProduct(_x3) {
        return _loadProduct.apply(this, arguments);
      }
      return loadProduct;
    }()
  }, {
    key: "replaceLoaderWithProduct",
    value: function replaceLoaderWithProduct(productOutput) {
      var loaderContainer = this.querySelector('.product-loader-container');
      if (loaderContainer) {
        loaderContainer.innerHTML = '';
        loaderContainer.appendChild(productOutput);
        if (typeof productOutput.init === 'function') {
          productOutput.init();
        }
      } else {
        this.innerHTML = '';
        this.appendChild(productOutput);
      }
    }
  }, {
    key: "replaceDogName",
    value: function replaceDogName() {
      if (localStorage.getItem('quiz') && document.querySelector('.dog-name')) {
        var _quizObj$inputs$input;
        var quizObj = JSON.parse(localStorage.getItem('quiz'));
        var inputKeys = Object.keys(quizObj.inputs);
        var name = quizObj === null || quizObj === void 0 || (_quizObj$inputs$input = quizObj.inputs[inputKeys[1]]) === null || _quizObj$inputs$input === void 0 ? void 0 : _quizObj$inputs$input.value;
        document.querySelectorAll('.dog-name').forEach(function (el) {
          return el.innerHTML = name;
        });
      }
    }
  }, {
    key: "replaceBreedName",
    value: function replaceBreedName() {
      if (localStorage.getItem('quiz') && document.querySelector('.breed-name')) {
        var quizData = JSON.parse(localStorage.getItem('quiz'));
        var breedName = quizData.dropdownStates && quizData.dropdownStates['entry.62437307'];
        document.querySelectorAll('.breed-name').forEach(function (el) {
          return el.innerHTML = breedName;
        });
      }
    }
  }, {
    key: "reload",
    value: function () {
      var _reload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.checkCheckboxes();
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function reload() {
        return _reload.apply(this, arguments);
      }
      return reload;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomProductLoader);

/***/ }),

/***/ "./src/assets/js/quiz-components/custom-product-output.js":
/*!****************************************************************!*\
  !*** ./src/assets/js/quiz-components/custom-product-output.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomProductOutput = /*#__PURE__*/function (_HTMLElement) {
  function CustomProductOutput() {
    var _this;
    _classCallCheck(this, CustomProductOutput);
    _this = _callSuper(this, CustomProductOutput);
    _this.mainSwiper = _this.querySelectorAll('.main-swiper');
    _this.thumbSwiper = _this.querySelectorAll('.thumb-slider');
    _this.prevButton = _this.querySelectorAll('.product-button-prev');
    _this.nextButton = _this.querySelectorAll('.product-button-next');
    _this.pagination = _this.querySelectorAll('.product-slider__pagination');
    return _this;
  }
  _inherits(CustomProductOutput, _HTMLElement);
  return _createClass(CustomProductOutput, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var checkSwiper = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          _this2.initSlider();
          clearInterval(checkSwiper);
        }
      }, 100);
    }
  }, {
    key: "initSlider",
    value: function initSlider() {
      var _this3 = this;
      this.mainSwiper.forEach(function (swiper, index) {
        _this3.sliderThumb = new Swiper(_this3.thumbSwiper[index], {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: false
        });
        _this3.activeSlider = new Swiper(swiper, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          allowTouchMove: true,
          navigation: {
            nextEl: _this3.nextButton[index],
            prevEl: _this3.prevButton[index]
          },
          pagination: {
            el: _this3.pagination[index],
            clickable: true
          },
          thumbs: {
            swiper: _this3.sliderThumb
          }
        });
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomProductOutput);

/***/ }),

/***/ "./src/assets/js/quiz-components/custom-review-slider.js":
/*!***************************************************************!*\
  !*** ./src/assets/js/quiz-components/custom-review-slider.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomReviewSlider = /*#__PURE__*/function (_HTMLElement) {
  function CustomReviewSlider() {
    var _this;
    _classCallCheck(this, CustomReviewSlider);
    _this = _callSuper(this, CustomReviewSlider);
    _this.sliderItem = _this.querySelector('.swiper');
    _this.sliderSlides = _this.sliderItem.querySelectorAll('.swiper-slide');
    _this.prevButton = _this.querySelector('.custom-review-slider__nav-prev');
    _this.nextButton = _this.querySelector('.custom-review-slider__nav-next');
    _this.pagination = _this.querySelector('.custom-review-slider__pagination');
    return _this;
  }
  _inherits(CustomReviewSlider, _HTMLElement);
  return _createClass(CustomReviewSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var checkSwiper = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          var _Object$values$find, _quizData$inputs;
          var quizData = JSON.parse(localStorage.getItem('quiz'));
          var currentBreed = (_Object$values$find = Object.values((_quizData$inputs = quizData === null || quizData === void 0 ? void 0 : quizData.inputs) !== null && _quizData$inputs !== void 0 ? _quizData$inputs : {}).find(function (field) {
            return (field === null || field === void 0 ? void 0 : field.entry) === "entry.62437307";
          })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.value;
          _this2.sliderSlides.forEach(function (slide) {
            if (slide.dataset.breed.toLowerCase() === (currentBreed === null || currentBreed === void 0 ? void 0 : currentBreed.toLowerCase())) {
              slide.classList.add('showed');
            }
          });
          var showedSlides = _toConsumableArray(_this2.sliderSlides).map(function (slide) {
            return slide.classList.contains('showed');
          }).filter(Boolean);
          if (showedSlides.length) {
            _this2.initSlider();
          } else {
            _this2.classList.add('hidden');
          }
          clearInterval(checkSwiper);
        }
      }, 100);
    }
  }, {
    key: "initSlider",
    value: function initSlider() {
      this.activeSlider = new Swiper(this.sliderItem, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: false,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton
        },
        pagination: {
          el: this.pagination,
          clickable: true
        }
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomReviewSlider);

/***/ }),

/***/ "./src/assets/js/quiz-components/date-step-input.js":
/*!**********************************************************!*\
  !*** ./src/assets/js/quiz-components/date-step-input.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var DateStepInput = /*#__PURE__*/function (_HTMLElement) {
  function DateStepInput() {
    var _this;
    _classCallCheck(this, DateStepInput);
    _this = _callSuper(this, DateStepInput);
    _this.quizContainer = _this.closest('quiz-container');
    _this.entry = _this.dataset.entry;
    _this.dateInput = _this.querySelector('.custom-input-date');
    _this.buttonDate = _this.querySelector('.custom-button-date');
    _this.rangeInput = _this.querySelector('custom-input-range');
    _this.rangeInputWrapper = _this.querySelector('.custom-range-date');
    _this.dateInput.maxLength = 10;
    return _this;
  }
  _inherits(DateStepInput, _HTMLElement);
  return _createClass(DateStepInput, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.dateInput.addEventListener('input', function () {
        _this2.saveInputValue('date', _this2.dateInput.value);
        if (_this2.dateInput.value) {
          _this2.hideRangeInput();
          _this2.saveInputValue('buttonClicked', false);
        } else {
          _this2.setDefaultDate();
        }
        _this2.quizContainer.validateInputs();
        _this2.updateAge();
      });
      this.buttonDate.addEventListener('click', function () {
        var isButtonClicked = !_this2.rangeInputWrapper.classList.contains('tw-hidden');
        _this2.saveInputValue('buttonClicked', !isButtonClicked);
        if (isButtonClicked) {
          _this2.hideRangeInput();
        } else {
          _this2.showRangeInput();
        }
      });
    }
  }, {
    key: "updateAge",
    value: function updateAge() {
      var date = this.dateInput.value ? new Date(this.dateInput.value) : new Date();
      var year = date.getFullYear();
      var currentYear = new Date().getFullYear();
      var age = currentYear - year;
      if (!this.querySelector('.custom-button-date').classList.contains('active-button')) {
        var _this$rangeInput;
        this.rangeInput.value = age;
        (_this$rangeInput = this.rangeInput) === null || _this$rangeInput === void 0 || (_this$rangeInput = _this$rangeInput.sliderInstance) === null || _this$rangeInput === void 0 || _this$rangeInput.set(age);
        this.rangeInput.updateImage();
      }
    }
  }, {
    key: "saveInputValue",
    value: function saveInputValue(key, value) {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      quizData.dateStepInput = quizData.dateStepInput || {};
      quizData.dateStepInput[this.entry] = _objectSpread(_objectSpread({}, quizData.dateStepInput[this.entry]), {}, _defineProperty({}, key, value));
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }
  }, {
    key: "restoreState",
    value: function restoreState() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData.dateStepInput && quizData.dateStepInput[this.entry]) {
        var _quizData$dateStepInp = quizData.dateStepInput[this.entry],
          date = _quizData$dateStepInp.date,
          buttonClicked = _quizData$dateStepInp.buttonClicked;
        if (date) {
          this.dateInput.value = date;
        } else {
          this.setDefaultDate();
        }
        if (buttonClicked) {
          this.showRangeInput();
        } else {
          this.hideRangeInput();
        }
      } else {
        this.setDefaultDate();
      }
    }
  }, {
    key: "setDefaultDate",
    value: function setDefaultDate() {
      var today = new Date();
      var formattedDate = this.formatDate(today);
      this.dateInput.value = formattedDate;
      this.saveInputValue('date', formattedDate);
      this.hideRangeInput();
      this.updateAge();
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      var day = String(date.getDate()).padStart(2, '0');
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var year = date.getFullYear();
      return "".concat(day, ".").concat(month, ".").concat(year);
    }
  }, {
    key: "hideRangeInput",
    value: function hideRangeInput() {
      var _this$quizContainer;
      this.buttonDate.classList.remove('active-button');
      this.rangeInputWrapper.classList.add('tw-hidden');
      (_this$quizContainer = this.quizContainer) === null || _this$quizContainer === void 0 || (_this$quizContainer = _this$quizContainer.activeSlider) === null || _this$quizContainer === void 0 || _this$quizContainer.update();
    }
  }, {
    key: "showRangeInput",
    value: function showRangeInput() {
      var _this$quizContainer2;
      this.buttonDate.classList.add('active-button');
      this.rangeInputWrapper.classList.remove('tw-hidden');
      (_this$quizContainer2 = this.quizContainer) === null || _this$quizContainer2 === void 0 || (_this$quizContainer2 = _this$quizContainer2.activeSlider) === null || _this$quizContainer2 === void 0 || _this$quizContainer2.update();
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.setEventListeners();
      this.restoreState();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DateStepInput);

/***/ }),

/***/ "./src/assets/js/quiz-components/empty-text-modal.js":
/*!***********************************************************!*\
  !*** ./src/assets/js/quiz-components/empty-text-modal.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var EmptyTextModal = /*#__PURE__*/function (_HTMLElement) {
  function EmptyTextModal() {
    var _this$quizContainer;
    var _this;
    _classCallCheck(this, EmptyTextModal);
    _this = _callSuper(this, EmptyTextModal);
    _this.quizContainer = _this.closest('quiz-container');
    _this.openButton = (_this$quizContainer = _this.quizContainer) === null || _this$quizContainer === void 0 ? void 0 : _this$quizContainer.querySelector('.trigger-button__modal-window');
    _this.modalOverlay = _this.querySelector('.modal-window__overlay');
    _this.closeButton = _this.querySelector('.modal-window__close');
    _this.modalWindow = _this.querySelector('.modal-window__wrapper');
    return _this;
  }
  _inherits(EmptyTextModal, _HTMLElement);
  return _createClass(EmptyTextModal, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }, {
    key: "assignEventListeners",
    value: function assignEventListeners() {
      var _this2 = this;
      this.modalOverlay.onclick = function (event) {
        if (event.target === event.currentTarget) {
          _this2.closeModal();
        }
      };
      this.closeButton.onclick = function () {
        _this2.closeModal();
      };
      if (this.openButton) {
        this.openButton.onclick = function () {
          if (!_this2.quizContainer.allowedToShowWarning) {
            _this2.quizContainer.allowedToShowWarning = true;
            return;
          }
          _this2.childButton = _this2.openButton.querySelector('.button--disabled');
          if (_this2.childButton) {
            _this2.openModal();
          }
        };
      }
    }
  }, {
    key: "init",
    value: function init() {
      this.assignEventListeners();
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.modalWindow.style.display = "none";
      this.modalOverlay.style.display = 'none';
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.modalWindow.style.display = "block";
      this.modalOverlay.style.display = 'block';
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EmptyTextModal);

/***/ }),

/***/ "./src/assets/js/quiz-components/new-product.js":
/*!******************************************************!*\
  !*** ./src/assets/js/quiz-components/new-product.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var NewProduct = /*#__PURE__*/function (_HTMLElement) {
  function NewProduct() {
    var _this;
    _classCallCheck(this, NewProduct);
    _this = _callSuper(this, NewProduct);
    _this.buyButton = document.querySelector('.redirect_to_product');
    return _this;
  }
  _inherits(NewProduct, _HTMLElement);
  return _createClass(NewProduct, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
      this.redirectToPdp();
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "redirectToPdp",
    value: function redirectToPdp() {
      var _this2 = this;
      if (this.buyButton && this.buyButton.classList.contains('redirect_to_product')) {
        this.buyButton.classList.remove('add-to-cart-btn');
        this.buyButton.addEventListener('click', function (e) {
          return _this2.redirectToProduct(e);
        });
        var nextButton = document.querySelector('.button.button--next.button-result-step');
        if (nextButton) {
          nextButton.replaceWith(nextButton.cloneNode(true));
          var newNextButton = document.querySelector('.button.button--next.button-result-step');
          newNextButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this2.redirectToProduct(e);
          }, true);
        }
      }
    }
  }, {
    key: "redirectToProduct",
    value: function redirectToProduct(event) {
      event.preventDefault();
      var quizData = JSON.parse(localStorage.getItem('quiz'));
      var productHandle;
      if (Array.isArray(quizData.productHandles) && quizData.productHandles.length > 0) {
        productHandle = quizData.productHandles[0];
      } else if (typeof quizData.productHandles === 'string') {
        productHandle = quizData.productHandles;
      }
      window.location.href = "https://heyholy.com/products/".concat(productHandle);
    }

    // async cleanCart() {
    //     try {
    //         const response = await fetch('/cart/clear.js', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             }
    //         });

    //         if (response.ok) {
    //             console.log('Cart cleaned successfully');
    //             // Optionally, you can update the cart UI or trigger a cart update event here
    //         } else {
    //             console.error('Failed to clean cart:', response.statusText);
    //         }
    //     } catch (error) {
    //         console.error('Error cleaning cart:', error);
    //     }
    // }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NewProduct);

/***/ }),

/***/ "./src/assets/js/quiz-components/new-quiz-cart.js":
/*!********************************************************!*\
  !*** ./src/assets/js/quiz-components/new-quiz-cart.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var NewQuizCart = /*#__PURE__*/function (_HTMLElement) {
  function NewQuizCart() {
    _classCallCheck(this, NewQuizCart);
    return _callSuper(this, NewQuizCart);
  }
  _inherits(NewQuizCart, _HTMLElement);
  return _createClass(NewQuizCart, [{
    key: "refresh",
    value: function refresh() {
      var _this = this;
      this.setLoading();
      fetch(window.location.href).then(function (response) {
        return response.text();
      }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        _this.querySelector('.new-quiz-cart-inner').innerHTML = doc.querySelector('.new-quiz-cart-inner').innerHTML;
        setTimeout(function () {
          _this.initCartds();
          _this.removeLoading();
          _this.checkCartEmptyAndSlide();
        }, 0);
      })["catch"](function (err) {
        console.warn('Something went wrong.', err);
      });
    }
  }, {
    key: "setLoading",
    value: function setLoading() {
      this.classList.add('loading');
    }
  }, {
    key: "removeLoading",
    value: function removeLoading() {
      this.classList.remove('loading');
    }
  }, {
    key: "initCartds",
    value: function initCartds() {
      if (this.querySelector('quiz-cart-checkout-item')) {
        this.querySelectorAll('quiz-cart-checkout-item').forEach(function (item) {
          item.init();
        });
      }
    }
  }, {
    key: "checkCartEmptyAndSlide",
    value: function checkCartEmptyAndSlide() {
      var cartItems = this.querySelectorAll('quiz-cart-checkout-item');
      if (cartItems.length === 0) {
        var quizContainer = document.querySelector('quiz-container');
        if (quizContainer && quizContainer.activeSlider) {
          var activeSlide = quizContainer.activeSlider.slides[quizContainer.activeSlider.activeIndex];
          var isLastSlide = quizContainer.activeSlider.activeIndex === quizContainer.activeSlider.slides.length - 1;
          if (activeSlide.classList.contains('swiper-slider__cart') || activeSlide.querySelector('quiz-custom-cart') || isLastSlide) {
            this.moveToResultSlide();
          }
        }
      }
    }
  }, {
    key: "moveToResultSlide",
    value: function moveToResultSlide() {
      var quizContainer = document.querySelector('quiz-container');
      if (quizContainer && quizContainer.activeSlider) {
        var slides = quizContainer.activeSlider.slides;
        var resultSlideIndex = Array.from(slides).findIndex(function (slide) {
          return slide.classList.contains('swiper-slider__result-step');
        });
        if (resultSlideIndex !== -1) {
          quizContainer.activeSlider.slideTo(resultSlideIndex);
        } else {
          console.warn('Result slide not found');
        }
      } else {
        console.warn('Quiz container or active slider not found');
      }
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      document.addEventListener('sliderChange', function () {
        _this2.refresh();
      });
      document.addEventListener('cart:updated', function () {
        _this2.refresh();
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.setEventListeners();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NewQuizCart);

/***/ }),

/***/ "./src/assets/js/quiz-components/quiz-cart-checkout-item.js":
/*!******************************************************************!*\
  !*** ./src/assets/js/quiz-components/quiz-cart-checkout-item.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuizCartCheckoutItem = /*#__PURE__*/function (_HTMLElement) {
  function QuizCartCheckoutItem() {
    var _this;
    _classCallCheck(this, QuizCartCheckoutItem);
    _this = _callSuper(this, QuizCartCheckoutItem);
    _this.cartContainer = _this.closest('new-quiz-cart');
    _this.quantityInput = _this.querySelector('.quiz-checkout__item__subscription__product-purchase__qty-wrapper__label');
    _this.minusBtn = _this.querySelector('.quiz-checkout__item__subscription__product-purchase__qty-wrapper__minus');
    _this.plusBtn = _this.querySelector('.quiz-checkout__item__subscription__product-purchase__qty-wrapper__plus');
    _this.itemKey = _this.getAttribute('data-item-key');
    _this.isUpdating = false;
    return _this;
  }
  _inherits(QuizCartCheckoutItem, _HTMLElement);
  return _createClass(QuizCartCheckoutItem, [{
    key: "updateItem",
    value: function () {
      var _updateItem = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(lineItemKey, quantity) {
        var response, updatedCart, updatedItem, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.isUpdating) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.isUpdating = true;
              this.classList.add('loading');
              _context.p = 2;
              _context.n = 3;
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: lineItemKey,
                  quantity: parseInt(quantity)
                })
              });
            case 3:
              response = _context.v;
              _context.n = 4;
              return response.json();
            case 4:
              updatedCart = _context.v;
              console.log('Product updated', updatedCart);
              document.dispatchEvent(new CustomEvent('cart:updated'));

              // Check if the item still exists in the cart
              updatedItem = updatedCart.items.find(function (item) {
                return item.key === lineItemKey;
              });
              if (updatedItem) {
                this.quantityInput.value = updatedItem.quantity;
              } else {
                // Item was removed, you might want to remove this element from the DOM
                this.remove();
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error('Failed to update product:', _t);
            case 6:
              _context.p = 6;
              this.classList.remove('loading');
              this.isUpdating = false;
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[2, 5, 6, 7]]);
      }));
      function updateItem(_x, _x2) {
        return _updateItem.apply(this, arguments);
      }
      return updateItem;
    }()
  }, {
    key: "changeQuantity",
    value: function () {
      var _changeQuantity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(change) {
        var currentQty, newQty;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.isUpdating) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              currentQty = parseInt(this.quantityInput.value) || 0;
              newQty = currentQty + change; // Allow newQty to be 0, which will remove the item from the cart
              if (newQty < 0) newQty = 0;
              this.quantityInput.value = newQty;
              _context2.n = 2;
              return this.updateItem(this.itemKey, newQty);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function changeQuantity(_x3) {
        return _changeQuantity.apply(this, arguments);
      }
      return changeQuantity;
    }()
  }, {
    key: "increaseQuantity",
    value: function increaseQuantity() {
      this.changeQuantity(1);
    }
  }, {
    key: "decreaseQuantity",
    value: function decreaseQuantity() {
      this.changeQuantity(-1);
    }
  }, {
    key: "handleManualQuantityChange",
    value: function () {
      var _handleManualQuantityChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var newQty;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!this.isUpdating) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              newQty = parseInt(this.quantityInput.value) || 0; // Allow newQty to be 0, which will remove the item from the cart
              if (newQty < 0) {
                newQty = 0;
                this.quantityInput.value = 0;
              }
              _context3.n = 2;
              return this.updateItem(this.itemKey, newQty);
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleManualQuantityChange() {
        return _handleManualQuantityChange.apply(this, arguments);
      }
      return handleManualQuantityChange;
    }()
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      if (this.minusBtn) {
        this.minusBtn.addEventListener('click', function () {
          return _this2.decreaseQuantity();
        });
      }
      if (this.plusBtn) {
        this.plusBtn.addEventListener('click', function () {
          return _this2.increaseQuantity();
        });
      }
      if (this.quantityInput) {
        this.quantityInput.addEventListener('change', function () {
          return _this2.handleManualQuantityChange();
        });
        this.quantityInput.addEventListener('blur', function () {
          return _this2.handleManualQuantityChange();
        });
      }
    }
  }, {
    key: "init",
    value: function init() {
      this.setEventListeners();
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizCartCheckoutItem);

/***/ }),

/***/ "./src/assets/js/quiz-components/quiz-cart-upsell-new.js":
/*!***************************************************************!*\
  !*** ./src/assets/js/quiz-components/quiz-cart-upsell-new.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuizCartUpsellNew = /*#__PURE__*/function (_HTMLElement) {
  function QuizCartUpsellNew() {
    var _this;
    _classCallCheck(this, QuizCartUpsellNew);
    _this = _callSuper(this, QuizCartUpsellNew);
    _this.quantityInput = _this.querySelector('.quiz-upsell-product-purchase__qty-wrapper__label');
    _this.minusBtn = _this.querySelector('.quiz-upsell-product-purchase__qty-wrapper__minus');
    _this.plusBtn = _this.querySelector('.quiz-upsell-product-purchase__qty-wrapper__plus');
    _this.atcButton = _this.querySelector('.quiz-upsell-product-checkbox__button-atc') ? _this.querySelector('.quiz-upsell-product-checkbox__button-atc') : '';
    _this.removeButton = _this.querySelector('.quiz-upsell-product-checkbox__button--remove') ? _this.querySelector('.quiz-upsell-product-checkbox__button--remove') : '';
    _this.variantId = _this.getAttribute('data-variant-id');
    _this.plansData = _this.parsePlans(_this.getAttribute('data-plans'));
    _this.subscriptionId = _this.getAttribute('data-subscription');
    _this.maxQuantity = _this.getAttribute('max') ? parseInt(_this.getAttribute('max')) : null;
    _this.loader = _this.closest('custom-product-loader');
    return _this;
  }
  _inherits(QuizCartUpsellNew, _HTMLElement);
  return _createClass(QuizCartUpsellNew, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }, {
    key: "init",
    value: function init() {
      this.setEventListeners();
      this.updateFrequencyUI();
    }
  }, {
    key: "parsePlans",
    value: function parsePlans(plansString) {
      try {
        return JSON.parse(plansString);
      } catch (error) {
        console.error('Error parsing plans:', error);
        return [];
      }
    }
  }, {
    key: "extractFrequencies",
    value: function extractFrequencies() {
      var _this2 = this;
      if (this.plansData.length === 0 || !this.plansData[0].selling_plans) {
        console.error('No valid plans data found');
        return [];
      }
      var sellingPlans = this.plansData[0].selling_plans;
      var frequencies = sellingPlans.map(function (plan) {
        var option = plan.options[0].value;
        return _this2.extractFrequency(option);
      }).filter(function (freq) {
        return freq !== null;
      });
      return frequencies.sort(function (a, b) {
        return a - b;
      });
    }
  }, {
    key: "extractFrequency",
    value: function extractFrequency(option) {
      var match = option.match(/(\d+)\s*(Week|Woche|Semaine)/i);
      return match ? match[1] : null;
    }
  }, {
    key: "updateFrequencyUI",
    value: function updateFrequencyUI() {
      // Implement this method to update your UI with the available frequencies
      console.log('Available frequencies:', this.frequencies);
      // For example, you could create a dropdown or radio buttons here
    }
  }, {
    key: "increaseQuantity",
    value: function increaseQuantity() {
      var currentQuantity = parseInt(this.quantityInput.value);
      if (this.maxQuantity === null || currentQuantity < this.maxQuantity) {
        this.quantityInput.value = currentQuantity + 1;
      } else {
        console.log('Maximum quantity reached');
        // Optionally, you can show a message to the user here
      }
    }
  }, {
    key: "decreaseQuantity",
    value: function decreaseQuantity() {
      if (parseInt(this.quantityInput.value) > 1) {
        this.quantityInput.value = parseInt(this.quantityInput.value) - 1;
      }
    }
  }, {
    key: "cleanCart",
    value: function () {
      var _cleanCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return fetch("/cart/clear.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                }
              });
            case 1:
              response = _context.v;
              if (response.ok) {
                console.log("Cart cleaned successfully");
                // Optionally, you can update the cart UI or trigger a cart update event here
              } else {
                console.error("Failed to clean cart:", response.statusText);
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error("Error cleaning cart:", _t);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      function cleanCart() {
        return _cleanCart.apply(this, arguments);
      }
      return cleanCart;
    }()
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this3 = this;
      this.minusBtn.addEventListener('click', function () {
        _this3.decreaseQuantity();
      });
      this.plusBtn.addEventListener('click', function () {
        _this3.increaseQuantity();
      });
      if (this.atcButton) {
        this.atcButton.addEventListener('click', function () {
          _this3.addToCart();
        });
      }
      if (this.removeButton) {
        this.removeButton.addEventListener('click', function () {
          _this3.removeFromCart();
        });
      }

      // Add event listener for manual input
      this.quantityInput.addEventListener('change', function () {
        _this3.validateQuantityInput();
      });
      document.addEventListener('ajaxProduct:added', function () {
        console.log('Cart updated');
        setTimeout(function () {
          _this3.loader.reload();
        }, 700);
      });
    }
  }, {
    key: "validateQuantityInput",
    value: function validateQuantityInput() {
      var quantity = parseInt(this.quantityInput.value);
      if (isNaN(quantity) || quantity < 1) {
        quantity = 1;
      } else if (this.maxQuantity !== null && quantity > this.maxQuantity) {
        quantity = this.maxQuantity;
        console.log('Maximum quantity reached');
        // Optionally, you can show a message to the user here
      }
      this.quantityInput.value = quantity;
    }
  }, {
    key: "findSellingPlanById",
    value: function findSellingPlanById(id) {
      var _iterator = _createForOfIteratorHelper(this.plansData),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var group = _step.value;
          var _iterator2 = _createForOfIteratorHelper(group.selling_plans),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var plan = _step2.value;
              if (plan.id.toString() === id.toString()) {
                return plan;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
  }, {
    key: "addToCart",
    value: function () {
      var _addToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var quantity, properties, sellingPlan, frequency, unit;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              quantity = parseInt(this.quantityInput.value);
              properties = {
                "Quiz Upsell Product": "true"
              };
              if (this.subscriptionId && this.subscriptionId !== 'empty') {
                sellingPlan = this.findSellingPlanById(this.subscriptionId);
                if (sellingPlan) {
                  frequency = this.extractFrequency(sellingPlan.options[0].value);
                  unit = 'week(s)';
                  window.addToCart(this.variantId, quantity, frequency, unit, this.subscriptionId, this.atcButton, properties);
                } else {
                  console.error('No matching selling plan found for subscription ID:', this.subscriptionId);
                  window.addToCart(this.variantId, quantity, null, null, null, this.atcButton, properties);
                }
              } else {
                window.addToCart(this.variantId, quantity, null, null, null, this.atcButton, properties);
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function addToCart() {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }()
  }, {
    key: "removeFromCart",
    value: function () {
      var _removeFromCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this4 = this;
        var lineItemId, response, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              lineItemId = this.getAttribute('data-line-item-id');
              if (lineItemId) {
                _context3.n = 1;
                break;
              }
              console.error('Line item ID not found');
              return _context3.a(2);
            case 1:
              _context3.p = 1;
              _context3.n = 2;
              return fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  id: lineItemId,
                  quantity: 0
                })
              });
            case 2:
              response = _context3.v;
              if (response.ok) {
                console.log("Product removed from cart successfully");
                // Optionally, you can update the cart UI or trigger a cart update event here
                document.dispatchEvent(new CustomEvent('ajaxProduct:removed'));
                setTimeout(function () {
                  _this4.loader.reload();
                }, 700);
              } else {
                console.error("Failed to remove product from cart:", response.statusText);
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              console.error("Error removing product from cart:", _t2);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function removeFromCart() {
        return _removeFromCart.apply(this, arguments);
      }
      return removeFromCart;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizCartUpsellNew);

/***/ }),

/***/ "./src/assets/js/quiz-components/quiz-cart-upsell-wrapper.js":
/*!*******************************************************************!*\
  !*** ./src/assets/js/quiz-components/quiz-cart-upsell-wrapper.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuizCartUpsellWrapper = /*#__PURE__*/function (_HTMLElement) {
  function QuizCartUpsellWrapper() {
    var _this$upsellWrapper;
    var _this;
    _classCallCheck(this, QuizCartUpsellWrapper);
    _this = _callSuper(this, QuizCartUpsellWrapper);
    _this.upsellWrapper = document.querySelector('quiz-cart-upsell-wrapper');
    _this.isSkip = (_this$upsellWrapper = _this.upsellWrapper) !== null && _this$upsellWrapper !== void 0 && _this$upsellWrapper.getAttribute('data-skip-slide') ? true : false;
    _this.quizContainer = document.querySelector('quiz-container');
    return _this;
  }
  _inherits(QuizCartUpsellWrapper, _HTMLElement);
  return _createClass(QuizCartUpsellWrapper, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }, {
    key: "init",
    value: function init() {
      this.skipUpsellSlide();
    }
  }, {
    key: "skipUpsellSlide",
    value: function skipUpsellSlide() {
      var activeSlider = this.quizContainer.activeSlider;
      var slides = activeSlider ? activeSlider.slides : '';
      if (!slides) return;
      var currentIndex = activeSlider.activeIndex;
      var totalSlides = slides.length;
      if (currentIndex === totalSlides - 2) {
        if (this.upsellWrapper && this.isSkip) {
          activeSlider.slideNext();
        }
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizCartUpsellWrapper);

/***/ }),

/***/ "./src/assets/js/quiz-components/quiz-container.js":
/*!*********************************************************!*\
  !*** ./src/assets/js/quiz-components/quiz-container.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuizContainer = /*#__PURE__*/function (_HTMLElement) {
  function QuizContainer() {
    var _this$nextButton;
    var _this;
    _classCallCheck(this, QuizContainer);
    _this = _callSuper(this, QuizContainer);
    _this.slider = _this.querySelector('.swiper');
    _this.buttonWrapper = _this.querySelector('.buttons-wrapper');
    _this.prevButton = _this.querySelector('.button--previous');
    _this.nextButton = _this.querySelector('.button--next');
    _this.nextButtonDefaultText = (_this$nextButton = _this.nextButton) === null || _this$nextButton === void 0 ? void 0 : _this$nextButton.dataset.defaulttext;
    _this.footer = _this.querySelector('quiz-footer');
    _this.allowedToShowWarning = false;
    _this.stepSettings = JSON.parse(_this.querySelector('script[data-steps-info]').innerHTML);
    _this.quizRezult = _this.querySelector('quiz-result-page');
    _this.cartFeatures = _this.querySelector('.quiz-cart__feature');
    _this.googleFormUrl = _this.dataset.googleformurl;
    _this.utmParams = _this.getUTMParams(); // Added to store UTM parameters
    _this.quizContainer = _this.closest('quiz-container');
    _this.lastSlideChangeTime = null;
    _this.lastTrackedButtonType = null;
    _this.lastTrackedIndex = null;
    return _this;
  }
  _inherits(QuizContainer, _HTMLElement);
  return _createClass(QuizContainer, [{
    key: "initLocalStorage",
    value: function initLocalStorage() {
      var _this2 = this;
      // Check if 'quiz' object exists in localStorage, if not, create it
      if (!localStorage.getItem('quiz')) {
        localStorage.setItem('quiz', JSON.stringify({
          currentSlide: 0,
          inputs: {}
        }));
      } else {
        var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
        if (quizData.currentSlide !== undefined) {
          setTimeout(function () {
            return _this2.activeSlider.slideTo(quizData.currentSlide);
          }, 0); // Navigate to last viewed slide
        }
      }
    }
  }, {
    key: "initPageLoadTracking",
    value: function () {
      var _initPageLoadTracking = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var getCurrentTime, isFirstLoad, firstLoadTime, ipAddress, currentLoadTime, _firstLoadTime, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              getCurrentTime = function getCurrentTime() {
                return new Date().toISOString();
              };
              isFirstLoad = !localStorage.getItem('firstLoadTime');
              if (!isFirstLoad) {
                _context.n = 4;
                break;
              }
              firstLoadTime = getCurrentTime();
              localStorage.setItem('firstLoadTime', firstLoadTime);
              _context.p = 1;
              _context.n = 2;
              return this.getIPAddress();
            case 2:
              ipAddress = _context.v;
              this.trackEvent('Page Load', 'First Load', firstLoadTime, {
                ip_address: ipAddress
              });
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.trackEvent('Page Load', 'First Load', firstLoadTime);
            case 4:
              currentLoadTime = getCurrentTime();
              this.trackEvent('Page Load', 'Current Load', currentLoadTime);
              if (!isFirstLoad) {
                _firstLoadTime = localStorage.getItem('firstLoadTime');
                this.trackEvent('Page Load', 'First Load (Cached)', _firstLoadTime);
              }
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function initPageLoadTracking() {
        return _initPageLoadTracking.apply(this, arguments);
      }
      return initPageLoadTracking;
    }()
  }, {
    key: "getIPAddress",
    value: function () {
      var _getIPAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return fetch('https://api.ipify.org?format=json');
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.json();
            case 2:
              data = _context2.v;
              return _context2.a(2, data.ip);
          }
        }, _callee2);
      }));
      function getIPAddress() {
        return _getIPAddress.apply(this, arguments);
      }
      return getIPAddress;
    }()
  }, {
    key: "sendEventToGoogleAnalytics",
    value: function sendEventToGoogleAnalytics() {
      var _this3 = this;
      this.initPageLoadTracking();
      if (this.quizContainer) {
        this.quizContainer.addEventListener('click', function (event) {
          var buttonType;
          if (event.target.classList.contains('last-step-button')) {
            buttonType = 'Checkout';
          } else if (event.target.classList.contains('button-complete-step')) {
            buttonType = 'Quiz Complete';
          } else if (event.target.classList.contains('button-result-step')) {
            buttonType = 'Recommendation';
          } else if (event.target.classList.contains('button--previous')) {
            buttonType = 'Previous';
          } else if (event.target.classList.contains('button--next')) {
            buttonType = 'Next';
          } else if (event.target.classList.contains('payment-buttons')) {
            buttonType = 'Add to cart(recommendation page)';
          }
          if (buttonType) {
            var currentIndex = _this3.slider.swiper.activeIndex;
            if (buttonType !== _this3.lastTrackedButtonType || currentIndex !== _this3.lastTrackedIndex) {
              _this3.trackEvent('Quiz Navigation', buttonType, currentIndex);
              _this3.lastTrackedButtonType = buttonType;
              _this3.lastTrackedIndex = currentIndex;
            }
          }
        });
      }
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(eventCategory, eventAction, eventLabel) {
      if (typeof gtag === 'function') {
        gtag('event', eventAction, {
          'event_category': eventCategory,
          'event_label': eventLabel
        });
      }
    }
  }, {
    key: "sendObjectToGoogleForm",
    value: function sendObjectToGoogleForm() {
      console.log("sendObjectToGoogleForm____");
      var quizData = JSON.parse(localStorage.getItem('quiz'));
      if (!quizData || !this.googleFormUrl) {
        console.error('Quiz data or form URL is missing');
        return;
      }
      var formData = _objectSpread({}, this.utmParams); // Include UTM parameters

      var valueMappings = {
        "0": "Typ Staubsauger",
        "1": "Foodie",
        "2": "Normalo",
        "3": "Wählerisch",
        "4": "Food Diva"
      };
      var valueMappings_2 = {
        "0": "Deutlich unter-gewichtig",
        "1": "Leichtes unter-gewichtig",
        "2": "Genau richtig",
        "3": "Etwas über-gewichtig",
        "4": "Stark über-gewichtig"
      };
      if (quizData.productHandles) {
        formData['entry.9067533'] = quizData.productHandles[0];
      }
      Object.values(quizData.inputs).forEach(function (_ref) {
        var entry = _ref.entry,
          value = _ref.value;
        if (formData.hasOwnProperty(entry)) {
          formData[entry] = "".concat(formData[entry], ",").concat(value);
        } else {
          formData[entry] = value;
        }
      });
      var addOrUpdateFormData = function addOrUpdateFormData(key, value) {
        if (key === 'entry.300338555') {
          value = valueMappings[value] || value;
        }
        if (key === 'entry.1373088848') {
          value = valueMappings_2[value] || value;
        }
        if (formData.hasOwnProperty(key)) {
          formData[key] += ",".concat(value);
        } else {
          formData[key] = value;
        }
      };
      Object.entries(quizData.radioStates).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        return addOrUpdateFormData(key, value);
      });
      Object.entries(quizData.dropdownStates).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          value = _ref5[1];
        return addOrUpdateFormData(key, value);
      });
      if (quizData.rangeValues.hasOwnProperty('date-birthentry')) {
        var value = !document.querySelector('.custom-button-date').classList.contains('button--active') ? document.querySelector('.custom-input-date').value : quizData.rangeValues['date-birthentry'];
        addOrUpdateFormData('entry.349306094', value);
      }
      Object.entries(quizData.rangeValues).forEach(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
          key = _ref7[0],
          value = _ref7[1];
        if (key !== 'date-birthentry') {
          addOrUpdateFormData(key, value);
        }
      });
      Object.entries(quizData.checkboxStates).forEach(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
          key = _ref9[0],
          checkboxes = _ref9[1];
        checkboxes.filter(function (checkbox) {
          return checkbox.checked;
        }).forEach(function (checkbox) {
          return addOrUpdateFormData(key, checkbox.value);
        });
      });
      var formBody = Object.keys(formData).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(formData[key]);
      }).join('&');
      console.log({
        formBody: formBody
      });
      var submissionData = JSON.stringify(quizData);
      localStorage.setItem('quizSubmissionData', submissionData);
      fetch(this.googleFormUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formBody,
        mode: 'no-cors'
      }).then(function () {
        console.log('Form submitted successfully');
      })["catch"](function (error) {
        console.error('Error submitting form:', error);
      });
    }
  }, {
    key: "getUTMParams",
    value: function getUTMParams() {
      var params = new URLSearchParams(window.location.search);
      var utmParams = {};
      if (params.has('utm_source')) utmParams['entry.1347350044'] = params.get('utm_source');
      if (params.has('utm_medium')) utmParams['entry.218909686'] = params.get('utm_medium');
      if (params.has('utm_campaign')) utmParams['entry.1378265469'] = params.get('utm_campaign');
      if (params.has('utm_term')) utmParams['entry.960396381'] = params.get('utm_term');
      if (params.has('utm_content')) utmParams['entry.1334178920'] = params.get('utm_content');
      return utmParams;
    }
  }, {
    key: "fireSwitchEvent",
    value: function fireSwitchEvent() {
      var activeIndex = this.activeSlider.activeIndex;
      var event = new CustomEvent('slideChange', {
        detail: {
          activeIndex: activeIndex
        }
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "initSlider",
    value: function initSlider() {
      var _this4 = this,
        _this$footer;
      this.activeSlider = new Swiper(this.slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: false,
        autoHeight: true,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton
        },
        draggable: false
      });
      this.activeSlider.on('slideChange', function () {
        var _this4$footer;
        var currentSlide = _this4.activeSlider.slides[_this4.activeSlider.activeIndex];
        var title = currentSlide.dataset.title;
        var text = _this4.returnExtractedText(_this4.activeSlider.activeIndex);

        // Dispatch event slider change with active index
        var event = new CustomEvent('sliderChange', {
          detail: {
            activeIndex: _this4.activeSlider.activeIndex
          }
        });
        console.log('slide change', _this4.activeSlider.activeIndex);
        document.dispatchEvent(event);
        (_this4$footer = _this4.footer) === null || _this4$footer === void 0 || _this4$footer.updateBoth(title, text);
        _this4.updateButton(_this4.activeSlider.activeIndex);
        _this4.disableNextBtn();
        _this4.saveCurrentSlide();
        _this4.validateInputs();
        _this4.fireSwitchEvent();
        _this4.replaceDogName();
        _this4.replaceBreedName();
        _this4.sendEventToGoogleAnalytics();
        _this4.clickRestartButton();
        _this4.setLastStepListener();
        _this4.checkLastStep(_this4.activeSlider.activeIndex);
        _this4.hideButtonsBlock(_this4.activeSlider.activeIndex);
        _this4.isResultPage(_this4.activeSlider.activeIndex);
        _this4.replaceNextBtnText(_this4.activeSlider.activeIndex);
        _this4.allowedToShowWarning = false;
      });
      var currentSlide = this.activeSlider.slides[this.activeSlider.activeIndex];
      var title = currentSlide.dataset.title;
      var text = this.returnExtractedText(this.activeSlider.activeIndex);
      (_this$footer = this.footer) === null || _this$footer === void 0 || _this$footer.updateBoth(title, text);
      this.updateButton(this.activeSlider.activeIndex);
      this.validateInputs();
      this.fireSwitchEvent();
      if (this.prevButton) {
        this.prevButton.onclick = function () {
          return _this4.allowedToShowWarning = false;
        };
      }
      this.checkLastStep(this.activeSlider.activeIndex);
      this.isResultPage(this.activeSlider.activeIndex);
      this.replaceNextBtnText(this.activeSlider.activeIndex);
    }
  }, {
    key: "foodCalculations",
    value: function foodCalculations() {
      var _Object$values,
        _answers$dropdownStat,
        _answers$rangeValues,
        _answers$radioStates,
        _answers$radioStates2,
        _Object$values2,
        _Object$values3,
        _this5 = this;
      var answers = JSON.parse(localStorage.getItem('quiz')) || {};
      var ageCalculation = function ageCalculation() {
        var age = 0;
        if (answers.dateStepInput && answers.dateStepInput['date-birthentry']) {
          if (!answers.dateStepInput['date-birthentry'].buttonClicked) {
            var birthday = new Date(answers.dateStepInput['date-birthentry'].date);
            if (isNaN(birthday.getTime())) {
              console.warn('Invalid birthday date');
              return 0;
            }
            var currentDay = new Date();
            var difference = currentDay - birthday;
            age = Math.floor(difference / 31557600000);
          } else {
            age = +answers.rangeValues["date-birthentry"] || 0;
          }
        } else {
          console.warn('Missing date step input');
        }
        return Math.max(0, age);
      };
      var weight = +((_Object$values = Object.values(answers.inputs || {})) === null || _Object$values === void 0 || (_Object$values = _Object$values.find(function (field) {
        return field.entry === "entry.571080194";
      })) === null || _Object$values === void 0 ? void 0 : _Object$values.value) || 0;
      if (weight <= 0) {
        console.error('Invalid weight:', weight);
        return;
      }
      var food = ageCalculation();
      var breed = ((_answers$dropdownStat = answers.dropdownStates) === null || _answers$dropdownStat === void 0 ? void 0 : _answers$dropdownStat["entry.62437307"]) || "Unknown";
      var breedValue = breed;
      var weightCondition = +((_answers$rangeValues = answers.rangeValues) === null || _answers$rangeValues === void 0 ? void 0 : _answers$rangeValues["entry.1373088848"]) || 0;
      var kastration = ((_answers$radioStates = answers.radioStates) === null || _answers$radioStates === void 0 || (_answers$radioStates = _answers$radioStates["entry.724027174"]) === null || _answers$radioStates === void 0 ? void 0 : _answers$radioStates.trim()) || "Nein";
      var activity = ((_answers$radioStates2 = answers.radioStates) === null || _answers$radioStates2 === void 0 ? void 0 : _answers$radioStates2["entry.2024690081"]) || "guter-durchschnitt";
      var snack = +((_Object$values2 = Object.values(answers.inputs || {})) === null || _Object$values2 === void 0 || (_Object$values2 = _Object$values2.find(function (field) {
        return field.entry === "entry.1223905683";
      })) === null || _Object$values2 === void 0 ? void 0 : _Object$values2.value) || 0;
      var dogWetFood = +((_Object$values3 = Object.values(answers.inputs || {})) === null || _Object$values3 === void 0 || (_Object$values3 = _Object$values3.find(function (field) {
        return field.entry === "entry.886031407";
      })) === null || _Object$values3 === void 0 ? void 0 : _Object$values3.value) || 0;
      kastration = kastration === 'Ja' ? -10 : 0;
      switch (activity) {
        case 'couch-potatoe':
          activity = 0;
          break;
        case 'guter-durchschnitt':
          activity = 20;
          break;
        default:
          activity = 50;
      }
      if (food < 2) {
        food = 0.04;
      } else if (food >= 2 && food < 6) {
        food = 0;
      } else {
        food = -0.10;
      }
      switch (weightCondition) {
        case 0:
          weightCondition = -13;
          break;
        case 1:
          weightCondition = 10;
          break;
        case 2:
          weightCondition = 0;
          break;
        case 3:
          weightCondition = -7;
          break;
        default:
          weightCondition = 20;
      }
      breed = ['Golden Retriever', 'Labrador Retriever', 'Flat Coated Retriever', 'Andere Bulldogge', 'Anderer Retriever', 'Französische Bulldoggen', 'Old English Bulldog', 'American Bulldog', 'Continental Bulldog', 'Mops', 'Beagle', 'Cavalier King Charles Spaniel', 'West Highland White Terrier', 'Welsh Corgi'].includes(breed) ? -5 : 0;
      var D6;
      if (weight >= 2 && weight < 4) D6 = 0.41;else if (weight >= 4 && weight < 8) D6 = 0.33;else if (weight >= 8 && weight < 13) D6 = 0.28;else if (weight >= 13 && weight < 18) D6 = 0.25;else if (weight >= 18 && weight < 23) D6 = 0.23;else if (weight >= 23 && weight < 28) D6 = 0.22;else if (weight >= 28 && weight < 33) D6 = 0.21;else if (weight >= 33 && weight < 38) D6 = 0.20;else if (weight >= 38 && weight < 46) D6 = 0.20;else if (weight >= 46 && weight < 56) D6 = 0.19;else if (weight >= 56 && weight < 71) D6 = 0.18;else D6 = 0.17;
      var test = (100 + breed + weightCondition + kastration + activity) / 100;
      var D12 = ((D6 + food) * test).toFixed(2);
      var F12 = (D12 * weight).toFixed(2);
      var kgSeventyFive = Math.pow(weight, 0.75);
      var MjHalf = kgSeventyFive * 0.5;
      var N12 = Math.min(F12, MjHalf * 1.25);
      var P12 = Math.max(F12, MjHalf * 0.75);
      var R12 = Math.max(N12, P12);
      var caloriesSnack = 349;
      if (breedValue !== null && breedValue !== void 0 && breedValue.includes('Retriever')) caloriesSnack = 344;else if (breedValue !== null && breedValue !== void 0 && breedValue.includes('Bulldog')) caloriesSnack = 349;else if (breedValue !== null && breedValue !== void 0 && breedValue.includes('Kleine')) caloriesSnack = 357;else if (breedValue !== null && breedValue !== void 0 && breedValue.includes('Hütehunde')) caloriesSnack = 338;else if (breedValue !== null && breedValue !== void 0 && breedValue.includes('Minis')) caloriesSnack = 314;
      var caloriesD = caloriesSnack / 238.85;
      var caloriesE = caloriesD / 50;
      var calories = 391;
      if (breedValue !== null && breedValue !== void 0 && breedValue.includes('Retriever')) calories = 379;else if (breedValue !== null && breedValue !== void 0 && breedValue.includes('Bulldog')) calories = 371;else if (breedValue !== null && breedValue !== void 0 && breedValue.includes('Kleine')) calories = 379;else if (breedValue !== null && breedValue !== void 0 && breedValue.includes('Hütehunde')) calories = 371;else if (breedValue !== null && breedValue !== void 0 && breedValue.includes('Minis')) calories = 391;
      var T12 = R12 - snack * caloriesE;
      var wetP = 1;
      var dryP = 1;
      if (dogWetFood > 0 && dogWetFood <= 100) {
        dryP = dogWetFood / 100;
        wetP = 1 - dryP;
      } else {
        console.warn('Invalid dogWetFood value:', dogWetFood);
      }
      var feed = Math.ceil(T12 * 238.85 / calories * 100);
      var feedWet = Math.ceil(T12 * wetP / 0.53433 * 100);

      // Update UI
      var wetFoodCheckbox = this.closest('quiz-container').querySelector('#nassfutter');
      var dryFoodCheckbox = this.closest('quiz-container').querySelector('#trockenfutter');
      var barfFoodCheckbox = this.closest('quiz-container').querySelector('#barf-futter');
      var selbstgekochtFoodCheckbox = this.closest('quiz-container').querySelector('#selbstgekocht');
      var foodGrams = this.closest('quiz-container').querySelector('.grams');
      var isWetFoodSelected = wetFoodCheckbox.checked || barfFoodCheckbox.checked || selbstgekochtFoodCheckbox.checked;
      var isDryFoodSelected = dryFoodCheckbox.checked;
      if (isDryFoodSelected && !isWetFoodSelected) {
        if (feed > 0) {
          foodGrams.innerHTML = "".concat(feed, "g");
        }
      } else if (isWetFoodSelected || isDryFoodSelected && isWetFoodSelected) {
        if (feedWet > 0) {
          foodGrams.innerHTML = "".concat(feedWet, "g");
        } else if (feed > 0) {
          foodGrams.innerHTML = "".concat(feed, "g");
        }
      }
      var calculateFoodInterval = function calculateFoodInterval() {
        console.group('Food Interval Calculation');
        if (isNaN(feed) || feed <= 0) {
          console.error('Invalid feed value:', feed);
          console.groupEnd();
          return;
        }
        var finalResult = 7000 / feed / 7;
        console.log('Final result (days between feedings):', finalResult);
        var dropdownNumber;
        if (finalResult < 3) dropdownNumber = 1;else if (finalResult < 4) dropdownNumber = 2;else if (finalResult < 5) dropdownNumber = 3;else if (finalResult < 6) dropdownNumber = 4;else if (finalResult < 7) dropdownNumber = 5;else if (finalResult < 8) dropdownNumber = 6;else if (finalResult < 9) dropdownNumber = 7;else dropdownNumber = 8;
        console.log("Result ".concat(finalResult.toFixed(2), ", dropdown number:"), dropdownNumber);
        var week = dropdownNumber + 1;
        console.log('Weeks between feedings:', week);
        setFoodInterval(week);
        console.groupEnd();
      };
      var setFoodInterval = function setFoodInterval(number) {
        var frequency = _this5.quizContainer.querySelectorAll('.frequency');
        frequency === null || frequency === void 0 || frequency.forEach(function (el) {
          return el.innerHTML = number + ' Wochen';
        });
        _this5.quizContainer.querySelector('new-product-section').dataset.frequency = number;
      };
      calculateFoodInterval();

      // Update product handles
      if (!Array.isArray(answers.productHandles)) {
        answers.productHandles = [];
      } else {
        answers.productHandles.length = 0;
      }
      document.querySelectorAll('.custom-product').forEach(function (product) {
        return product.classList.remove('show');
      });
      if (window.breedSearchDatabreed) {
        Object.values(window.breedSearchDatabreed).forEach(function (data) {
          if (Array.isArray(data.breedList) && data.breedList.includes(breedValue)) {
            var productElement = document.querySelectorAll(".custom-product[data-product-id=\"".concat(data.productID, "\"]"));
            var _wetFoodCheckbox = _this5.closest('quiz-container').querySelector('#nassfutter');
            var _dryFoodCheckbox = _this5.closest('quiz-container').querySelector('#trockenfutter');
            if (productElement) {
              productElement.forEach(function (product) {
                var productHandle = product.getAttribute('data-product-handle');
                if (_wetFoodCheckbox.checked && !_dryFoodCheckbox.checked && productHandle.includes('nassfutter')) {
                  product.classList.add('show');
                } else if (_dryFoodCheckbox.checked && !_wetFoodCheckbox.checked && !productHandle.includes('nassfutter')) {
                  product.classList.add('show');
                } else if (_wetFoodCheckbox.checked && _dryFoodCheckbox.checked && !productHandle.includes('nassfutter')) {
                  product.classList.add('show');
                } else if (!_wetFoodCheckbox.checked && !productHandle.includes('nassfutter')) {
                  product.classList.add('show');
                }
                if (productHandle) {
                  answers.productHandles.push(productHandle);
                }
              });
            }
          }
        });
      } else {
        console.warn('breedSearchDatabreed not found');
      }
      localStorage.setItem('quiz', JSON.stringify(answers));
      console.groupEnd();
    }
  }, {
    key: "hideButtonsBlock",
    value: function hideButtonsBlock(index) {
      var currentSlide = this.activeSlider.slides[index];
      if (currentSlide.classList.contains('swiper-slider__hide_buttons_block')) {
        this.buttonWrapper.classList.add('!tw-hidden');
      } else {
        this.buttonWrapper.classList.remove('!tw-hidden');
      }
    }
  }, {
    key: "checkLastStep",
    value: function checkLastStep(index) {
      var currentSlide = this.activeSlider.slides[index];
      if (currentSlide.classList.contains('swiper-slider__last-step') || currentSlide.classList.contains('swiper-slider__bottom-content-hidden')) {
        var _this$footer2, _this$footer3;
        this.cartFeatures.classList.add('tw-hidden');
        (_this$footer2 = this.footer) === null || _this$footer2 === void 0 || _this$footer2.classList.remove('tw-block');
        (_this$footer3 = this.footer) === null || _this$footer3 === void 0 || _this$footer3.classList.add('tw-hidden');
        this.foodCalculations();
      } else {
        var _this$footer4, _this$footer5;
        this.cartFeatures.classList.add('tw-hidden');
        (_this$footer4 = this.footer) === null || _this$footer4 === void 0 || _this$footer4.classList.remove('tw-hidden');
        (_this$footer5 = this.footer) === null || _this$footer5 === void 0 || _this$footer5.classList.add('tw-block');
      }
      if (currentSlide.classList.contains('swiper-slider__complete-step')) {
        this.nextButton.classList.add('button-complete-step');
      } else {
        this.nextButton.classList.remove('button-complete-step');
      }
    }
  }, {
    key: "isResultPage",
    value: function isResultPage(index) {
      var currentSlide = this.activeSlider.slides[index];
      if (currentSlide.classList.contains('swiper-slider__result-step')) {
        var currentData = JSON.stringify(JSON.parse(localStorage.getItem('quiz'))); // Adjust if necessary to match your form data structure
        var lastSubmissionData = localStorage.getItem('quizSubmissionData');
        if (!lastSubmissionData || lastSubmissionData && currentData !== lastSubmissionData) {
          // The data is different or it's the first submission, proceed with submitting the form
          this.sendObjectToGoogleForm(); // Adjust this line if necessary
        } else {
          console.log('form already submitted');
        }
        this.removeOverflowForBody();
        this.buttonWrapper.classList.remove('sticky-wrapper');
        this.buttonWrapper.classList.add('simple-button-wrapper');
        this.quizContainer.style.paddingBottom = 0;
        this.nextButton.classList.add('button-result-step');
      } else if (currentSlide.classList.contains('swiper-slider__cart')) {
        this.quizContainer.style.paddingBottom = 70;
        this.buttonWrapper.classList.remove('simple-button-wrapper');
        this.nextButton.classList.remove('button-result-step');
        this.buttonWrapper.classList.add('sticky-wrapper');
      } else {
        this.quizContainer.style.paddingBottom = 70;
        this.buttonWrapper.classList.remove('simple-button-wrapper');
        this.nextButton.classList.remove('button-result-step');
        this.updateButton(this.activeSlider.activeIndex);
        this.buttonWrapper.classList.remove('buttons-cart__last-step');
        this.buttonWrapper.classList.add('sticky-wrapper');
      }
    }
  }, {
    key: "removeOverflowForBody",
    value: function removeOverflowForBody() {
      var body = document.body;
      document.addEventListener('cart:open', function () {
        body.classList.add('remove-overflow');
      });
      document.addEventListener('cart:close', function () {
        body.classList.remove('remove-overflow');
      });
    }
  }, {
    key: "setLastStepListener",
    value: function setLastStepListener() {
      var button = document.querySelector('button.button.button--next.swiper-button-disabled');
      if (!button) return;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.addEventListener('click', function () {
        var addItemsURL = "/checkout";
        window.location.href = addItemsURL;
      });
    }
  }, {
    key: "addCartFeatures",
    value: function addCartFeatures(index) {
      var currentSlide = this.activeSlider.slides[index];
      var totalSlides = this.activeSlider.slides.length;
      var currentIndex = Array.from(this.activeSlider.slides).indexOf(currentSlide);
      if (currentIndex === totalSlides - 1) {
        this.buttonWrapper.classList.add('buttons-cart__last-step');
        this.cartFeatures.classList.remove('tw-hidden');
        document.querySelector('quiz-container').classList.add('cart__last-step');
      } else {
        this.cartFeatures.classList.add('tw-hidden');
        this.buttonWrapper.classList.remove('buttons-cart__last-step');
      }
    }
  }, {
    key: "replaceNextBtnText",
    value: function replaceNextBtnText(index) {
      var currentSlide = this.activeSlider.slides[index];
      var text = currentSlide.dataset.nexttitle;
      if (this.nextButton) {
        if (text) {
          this.nextButton.innerHTML = text;
        } else {
          this.nextButton.innerHTML = this.nextButtonDefaultText;
        }
      }
    }
  }, {
    key: "returnExtractedText",
    value: function returnExtractedText(index) {
      var currentSlide = this.activeSlider.slides[index];
      var text = currentSlide.dataset.text;
      var parsedData = text ? JSON.parse(text) : '';
      var extractedText = '';
      if (!parsedData) return extractedText;
      parsedData.children.forEach(function (paragraph) {
        paragraph.children.forEach(function (textElement) {
          extractedText += textElement.value + ' ';
        });
      });
      return extractedText.trim();
    }
  }, {
    key: "replaceDogName",
    value: function replaceDogName() {
      if (localStorage.getItem('quiz') && document.querySelector('.dog-name')) {
        var _quizObj$inputs$input;
        var quizObj = JSON.parse(localStorage.getItem('quiz'));
        var inputKeys = Object.keys(quizObj.inputs);
        var name = quizObj === null || quizObj === void 0 || (_quizObj$inputs$input = quizObj.inputs[inputKeys[1]]) === null || _quizObj$inputs$input === void 0 ? void 0 : _quizObj$inputs$input.value;
        document.querySelectorAll('.dog-name').forEach(function (el) {
          return el.innerHTML = name;
        });
      }
    }
  }, {
    key: "replaceBreedName",
    value: function replaceBreedName() {
      if (localStorage.getItem('quiz') && document.querySelector('.breed-name')) {
        var quizData = JSON.parse(localStorage.getItem('quiz'));
        var breedName = quizData.dropdownStates && quizData.dropdownStates['entry.62437307'];
        document.querySelectorAll('.breed-name').forEach(function (el) {
          return el.innerHTML = breedName;
        });
      }
    }
  }, {
    key: "validateInputs",
    value: function validateInputs() {
      var currentSlide = this.activeSlider.slides[this.activeSlider.activeIndex];
      var inputs = currentSlide.querySelectorAll('input[type=checkbox]');
      var visibleInputs = Array.from(currentSlide.querySelectorAll('input')).filter(function (input) {
        return input.offsetParent !== null && window.getComputedStyle(input).display !== 'none';
      });
      var textInputs = visibleInputs.filter(function (input) {
        return input.type === 'text' || input.type === 'number';
      });
      var checkboxInputs = Array.from(inputs).filter(function (input) {
        return input.type === 'checkbox' || input.type === 'radio';
      });
      var textInputsFilled = true;
      var checkboxChecked = false;
      textInputs.forEach(function (input) {
        if (input.value === '') {
          textInputsFilled = false;
        }
      });
      checkboxInputs.forEach(function (checkbox) {
        if (checkbox.checked) {
          checkboxChecked = true;
        }
      });
      var checkboxMandatory = checkboxInputs.some(function (checkbox) {
        return checkbox.required;
      });
      if (textInputs.length > 0 && checkboxInputs.length === 0) {
        if (textInputsFilled) {
          this.enableNextBtn();
        } else {
          this.disableNextBtn();
        }
      } else if (checkboxInputs.length > 0 && textInputs.length === 0) {
        if (checkboxChecked || !checkboxMandatory) {
          this.enableNextBtn();
        } else {
          this.disableNextBtn();
        }
      } else if (textInputs.length > 0 && checkboxInputs.length > 0) {
        if (textInputsFilled && (checkboxChecked || !checkboxMandatory)) {
          this.enableNextBtn();
        } else {
          this.disableNextBtn();
        }
      } else {
        this.enableNextBtn();
      }
    }
  }, {
    key: "disableNextBtn",
    value: function disableNextBtn() {
      var _this$nextButton2;
      (_this$nextButton2 = this.nextButton) === null || _this$nextButton2 === void 0 || _this$nextButton2.classList.add('button--disabled');
    }
  }, {
    key: "enableNextBtn",
    value: function enableNextBtn() {
      var _this$nextButton3;
      (_this$nextButton3 = this.nextButton) === null || _this$nextButton3 === void 0 || _this$nextButton3.classList.remove('button--disabled');
    }
  }, {
    key: "updateButton",
    value: function updateButton(index) {
      console.log('updateButton', index);
      if (index === 0) {
        var _this$prevButton, _this$buttonWrapper, _this$buttonWrapper2;
        (_this$prevButton = this.prevButton) === null || _this$prevButton === void 0 || _this$prevButton.classList.add('tw-hidden');
        (_this$buttonWrapper = this.buttonWrapper) === null || _this$buttonWrapper === void 0 || _this$buttonWrapper.classList.add('tw-justify-center');
        (_this$buttonWrapper2 = this.buttonWrapper) === null || _this$buttonWrapper2 === void 0 || _this$buttonWrapper2.classList.remove('tw-justify-between');
      } else {
        var _this$prevButton2, _this$buttonWrapper3, _this$buttonWrapper4;
        (_this$prevButton2 = this.prevButton) === null || _this$prevButton2 === void 0 || _this$prevButton2.classList.remove('tw-hidden');
        (_this$buttonWrapper3 = this.buttonWrapper) === null || _this$buttonWrapper3 === void 0 || _this$buttonWrapper3.classList.remove('tw-justify-center');
        (_this$buttonWrapper4 = this.buttonWrapper) === null || _this$buttonWrapper4 === void 0 || _this$buttonWrapper4.classList.add('tw-justify-between');
      }
    }
  }, {
    key: "clickRestartButton",
    value: function clickRestartButton() {
      var restartButton = document.querySelector('.quiz__header-restart-link');
      restartButton.addEventListener('click', function () {
        localStorage.removeItem("quiz");
        localStorage.removeItem("quizSubmissionData");
        location.reload();
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this6 = this;
      var checkSwiper = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          _this6.initSlider();
          clearInterval(checkSwiper);
          _this6.initLocalStorage();
          _this6.sendEventToGoogleAnalytics();
        }
      }, 100);
    }
  }, {
    key: "saveCurrentSlide",
    value: function saveCurrentSlide() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      quizData.currentSlide = this.activeSlider.activeIndex;
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizContainer);

/***/ }),

/***/ "./src/assets/js/quiz-components/quiz-footer.js":
/*!******************************************************!*\
  !*** ./src/assets/js/quiz-components/quiz-footer.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuizFooter = /*#__PURE__*/function (_HTMLElement) {
  function QuizFooter() {
    var _this;
    _classCallCheck(this, QuizFooter);
    _this = _callSuper(this, QuizFooter);
    _this.mainTitle = _this.querySelector('.quiz-container-footer-title');
    _this.text = _this.querySelector('.quiz-container-footer-text');
    _this.quizContainer = _this.closest('quiz-container');
    return _this;
  }
  _inherits(QuizFooter, _HTMLElement);
  return _createClass(QuizFooter, [{
    key: "updateTitle",
    value: function updateTitle(title) {
      if (title) {
        this.mainTitle.style.display = 'block';
        this.mainTitle.innerHTML = title;
      } else {
        this.mainTitle.style.display = 'none';
        this.mainTitle.innerHTML = '';
      }
    }
  }, {
    key: "updateText",
    value: function updateText(text) {
      if (text.trim()) {
        this.text.style.display = 'block';
        this.text.innerHTML = text;
      } else {
        this.text.style.display = 'none';
        this.text.innerHTML = '';
      }
    }
  }, {
    key: "updateBoth",
    value: function updateBoth(title, text) {
      this.updateTitle(title);
      this.updateText(text);
      var activeSlider = this.quizContainer.activeSlider;
      if (!activeSlider) return;
      var slides = activeSlider.slides;
      var currentSlide = slides[activeSlider.activeIndex];
      if (currentSlide.hasAttribute('data-last-step')) {
        this.style.display = 'none';
      } else {
        if (title || text) {
          this.style.display = 'block';
        } else {
          this.style.display = 'none';
        }
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      // if needed
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizFooter);

/***/ }),

/***/ "./src/assets/js/quiz-components/quiz-progress-bar.js":
/*!************************************************************!*\
  !*** ./src/assets/js/quiz-components/quiz-progress-bar.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuizProgress = /*#__PURE__*/function (_HTMLElement) {
  function QuizProgress() {
    var _this;
    _classCallCheck(this, QuizProgress);
    _this = _callSuper(this, QuizProgress);
    _this.progressWrapper = _this.querySelector('.quiz-progress-bar__wrapper');
    _this.parentQuiz = _this.closest('quiz-container');
    _this.stepsInfo = _this.parentQuiz.stepSettings.steps_info;
    _this.uniqueSteps = _toConsumableArray(new Set(_this.stepsInfo.map(function (info) {
      return info.type;
    }))); // Get unique steps
    return _this;
  }
  _inherits(QuizProgress, _HTMLElement);
  return _createClass(QuizProgress, [{
    key: "createProgressSegments",
    value: function createProgressSegments() {
      var _this2 = this;
      var totalQuestions = this.stepsInfo.length;
      var minSegmentWidth = 20; // Set minimum segment width to 20%
      var totalSegments = this.uniqueSteps.length;

      // Calculate total width of minimum segments
      var totalMinWidth = minSegmentWidth * totalSegments;

      // Calculate remaining width to distribute
      var remainingWidth = totalMinWidth > 100 ? 0 : 100 - totalMinWidth;
      this.uniqueSteps.forEach(function (step, index) {
        var questionsInSegment = _this2.stepsInfo.filter(function (info) {
          return info.type === step;
        }).length;
        var segmentWidth = minSegmentWidth;
        if (remainingWidth > 0) {
          // Distribute remaining width proportionally
          var proportion = questionsInSegment / totalQuestions;
          segmentWidth += remainingWidth * proportion;
        }

        // Create the segment and fill elements
        var segment = document.createElement('div');
        var fill = document.createElement('div');
        fill.classList.add('fill');
        fill.style.width = '0%'; // Initialize with zero width

        segment.classList.add('progress-segment');
        segment.style.width = "".concat(segmentWidth, "%"); // Set width based on calculation
        segment.dataset.step = step;
        segment.dataset.questions = questionsInSegment;
        segment.appendChild(fill); // Append the fill div to the segment

        _this2.progressWrapper.appendChild(segment);

        // Set max-width for fill after appending to get correct offsetWidth
        fill.style.maxWidth = "".concat(segment.offsetWidth - 4, "px");
      });
    }
  }, {
    key: "updateProgress",
    value: function updateProgress(currentIndex) {
      var _this3 = this;
      var questionCounter = 0;
      var reachedCurrentIndex = false;
      var isLastStepInSegment = false; // Check if it's the last step in the segment

      this.stepsInfo.forEach(function (step, index) {
        if (index < currentIndex) {
          questionCounter += 1;
        } else if (index === currentIndex) {
          reachedCurrentIndex = true;
          questionCounter += 1; // Include the current question in the progress

          // Determine if the current index is the last step within its segment
          var nextStep = _this3.stepsInfo[index + 1];
          if (!nextStep || nextStep.type !== step.type) {
            isLastStepInSegment = true;
          }
        }
      });
      var currentSegmentIndex = this.uniqueSteps.indexOf(this.stepsInfo[currentIndex].type);
      var totalQuestionsInCurrentSegment = parseInt(this.progressWrapper.children[currentSegmentIndex].dataset.questions);

      // Fill 100% if it's the last step in the segment
      var progressInCurrentSegment = isLastStepInSegment ? 1 : reachedCurrentIndex ? (questionCounter - 1) / totalQuestionsInCurrentSegment : questionCounter / totalQuestionsInCurrentSegment;

      // Update segment widths based on current progress
      this.progressWrapper.childNodes.forEach(function (segment, index) {
        var fill = segment.querySelector('.fill'); // Get the fill div
        segment.querySelector('.fill').style.maxWidth = "".concat(segment.offsetWidth - 4, "px");
        if (fill) {
          if (index < currentSegmentIndex || isLastStepInSegment && index === currentSegmentIndex) {
            fill.style.width = '100%'; // Previous segments and current (if last step) are fully filled
            fill.classList.add('fill-full');
          } else if (index === currentSegmentIndex) {
            fill.style.width = "".concat(progressInCurrentSegment * 100, "%"); // Current segment filled proportionally
            // Add or remove fill-full class based on whether it's fully filled
            progressInCurrentSegment === 1 ? fill.classList.add('fill-full') : fill.classList.remove('fill-full');
          } else {
            fill.style.width = '0%'; // Future segments are not filled
            fill.classList.remove('fill-full');
          }
        }
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this4 = this;
      this.createProgressSegments();
      this.parentQuiz.addEventListener('slideChange', function (event) {
        _this4.updateProgress(event.detail.activeIndex);
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizProgress);

/***/ }),

/***/ "./src/assets/js/quiz-components/quiz-restart-banner.js":
/*!**************************************************************!*\
  !*** ./src/assets/js/quiz-components/quiz-restart-banner.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuizRestartBanner = /*#__PURE__*/function (_HTMLElement) {
  function QuizRestartBanner() {
    var _this;
    _classCallCheck(this, QuizRestartBanner);
    _this = _callSuper(this, QuizRestartBanner);
    _this.restartButton = _this.querySelector('.restart-banner__button');
    return _this;
  }
  _inherits(QuizRestartBanner, _HTMLElement);
  return _createClass(QuizRestartBanner, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.restartQuiz();
    }
  }, {
    key: "restartQuiz",
    value: function restartQuiz() {
      if (this.restartButton) {
        this.restartButton.addEventListener('click', function () {
          localStorage.removeItem('quiz');
          localStorage.removeItem('quizSubmissionData');
          location.reload();
        });
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizRestartBanner);

/***/ }),

/***/ "./src/assets/js/quiz-components/quiz-result-page.js":
/*!***********************************************************!*\
  !*** ./src/assets/js/quiz-components/quiz-result-page.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuizResultsPage = /*#__PURE__*/function (_HTMLElement) {
  function QuizResultsPage() {
    var _this;
    _classCallCheck(this, QuizResultsPage);
    _this = _callSuper(this, QuizResultsPage);
    _this.quizContainer = _this.closest('quiz-container');
    _this.positiveList = _this.querySelectorAll('.result-page__chart-aspects__positive-list');
    _this.defaultList = _this.querySelector('.result-page__chart-aspects__default');
    _this.defaultItems = _this.querySelectorAll('.result-page__chart-aspects__default-list');
    return _this;
  }
  _inherits(QuizResultsPage, _HTMLElement);
  return _createClass(QuizResultsPage, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.showPositiveCoulmns();
    }
  }, {
    key: "showPositiveCoulmns",
    value: function showPositiveCoulmns() {
      var quizData = JSON.parse(localStorage.getItem('quiz'));
      var problems = quizData.checkboxStates && quizData.checkboxStates['entry.249999288'];
      if (problems) {
        var checkedItems = problems.filter(function (item) {
          return item.checked;
        });
        var checkedCount = checkedItems.length;
        var hasKeineProblemChecked = checkedItems.some(function (item) {
          return item.textValue.toLowerCase().includes('keine probleme');
        });
        this.positiveList.forEach(function (element) {
          var issue = element.dataset.issue;
          problems.forEach(function (item) {
            if (item.checked) {
              var positiveItem = item.textValue.split('/-/')[0];
              if (issue === positiveItem) {
                element.classList.remove('!tw-hidden');
              }
            }
          });
        });
        var defaultItemsToShow = 0;
        if (hasKeineProblemChecked) {
          if (checkedCount === 1) {
            defaultItemsToShow = 3;
          } else {
            var otherCheckedCount = checkedCount - 1;
            defaultItemsToShow = Math.max(0, 3 - otherCheckedCount);
          }
        } else if (checkedCount < 3) {
          defaultItemsToShow = 3 - checkedCount;
        }
        this.defaultItems.forEach(function (item, index) {
          if (index < defaultItemsToShow) {
            item.classList.remove('!tw-hidden');
          } else {
            item.classList.add('!tw-hidden');
          }
        });
        if (defaultItemsToShow > 0) {
          this.defaultList.classList.remove('!tw-hidden');
        } else {
          this.defaultList.classList.add('!tw-hidden');
        }
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizResultsPage);

/***/ }),

/***/ "./src/assets/js/quiz.js":
/*!*******************************!*\
  !*** ./src/assets/js/quiz.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _quiz_components_quiz_container__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./quiz-components/quiz-container */ "./src/assets/js/quiz-components/quiz-container.js");
/* harmony import */ var _quiz_components_quiz_progress_bar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./quiz-components/quiz-progress-bar */ "./src/assets/js/quiz-components/quiz-progress-bar.js");
/* harmony import */ var _quiz_components_quiz_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./quiz-components/quiz-footer */ "./src/assets/js/quiz-components/quiz-footer.js");
/* harmony import */ var _quiz_components_empty_text_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./quiz-components/empty-text-modal */ "./src/assets/js/quiz-components/empty-text-modal.js");
/* harmony import */ var _quiz_components_custom_input_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./quiz-components/custom-input-text */ "./src/assets/js/quiz-components/custom-input-text.js");
/* harmony import */ var _quiz_components_custom_input_number__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./quiz-components/custom-input-number */ "./src/assets/js/quiz-components/custom-input-number.js");
/* harmony import */ var _quiz_components_custom_input_range__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./quiz-components/custom-input-range */ "./src/assets/js/quiz-components/custom-input-range.js");
/* harmony import */ var _quiz_components_custom_input_checkbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./quiz-components/custom-input-checkbox */ "./src/assets/js/quiz-components/custom-input-checkbox.js");
/* harmony import */ var _quiz_components_date_step_input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./quiz-components/date-step-input */ "./src/assets/js/quiz-components/date-step-input.js");
/* harmony import */ var _quiz_components_custom_input_radio__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./quiz-components/custom-input-radio */ "./src/assets/js/quiz-components/custom-input-radio.js");
/* harmony import */ var _quiz_components_custom_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./quiz-components/custom-form */ "./src/assets/js/quiz-components/custom-form.js");
/* harmony import */ var _quiz_components_custom_dropdown__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./quiz-components/custom-dropdown */ "./src/assets/js/quiz-components/custom-dropdown.js");
/* harmony import */ var _quiz_components_custom_review_slider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./quiz-components/custom-review-slider */ "./src/assets/js/quiz-components/custom-review-slider.js");
/* harmony import */ var _quiz_components_custom_product_output__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./quiz-components/custom-product-output */ "./src/assets/js/quiz-components/custom-product-output.js");
/* harmony import */ var _quiz_components_quiz_result_page__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./quiz-components/quiz-result-page */ "./src/assets/js/quiz-components/quiz-result-page.js");
/* harmony import */ var _quiz_components_quiz_restart_banner__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./quiz-components/quiz-restart-banner */ "./src/assets/js/quiz-components/quiz-restart-banner.js");
/* harmony import */ var _quiz_components_custom_product_loader__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./quiz-components/custom-product-loader */ "./src/assets/js/quiz-components/custom-product-loader.js");
/* harmony import */ var _quiz_components_new_product__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./quiz-components/new-product */ "./src/assets/js/quiz-components/new-product.js");
/* harmony import */ var _quiz_components_quiz_cart_upsell_new__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./quiz-components/quiz-cart-upsell-new */ "./src/assets/js/quiz-components/quiz-cart-upsell-new.js");
/* harmony import */ var _quiz_components_new_quiz_cart__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./quiz-components/new-quiz-cart */ "./src/assets/js/quiz-components/new-quiz-cart.js");
/* harmony import */ var _quiz_components_quiz_cart_checkout_item__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./quiz-components/quiz-cart-checkout-item */ "./src/assets/js/quiz-components/quiz-cart-checkout-item.js");
/* harmony import */ var _quiz_components_quiz_cart_upsell_wrapper__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./quiz-components/quiz-cart-upsell-wrapper */ "./src/assets/js/quiz-components/quiz-cart-upsell-wrapper.js");






















if (!customElements.get('quiz-cart-checkout-item')) {
  customElements.define('quiz-cart-checkout-item', _quiz_components_quiz_cart_checkout_item__WEBPACK_IMPORTED_MODULE_20__["default"]);
}
if (!customElements.get('new-quiz-cart')) {
  customElements.define('new-quiz-cart', _quiz_components_new_quiz_cart__WEBPACK_IMPORTED_MODULE_19__["default"]);
}
if (!customElements.get('quiz-cart-upsell-new')) {
  customElements.define('quiz-cart-upsell-new', _quiz_components_quiz_cart_upsell_new__WEBPACK_IMPORTED_MODULE_18__["default"]);
}
if (!customElements.get('quiz-cart-upsell-wrapper')) {
  customElements.define('quiz-cart-upsell-wrapper', _quiz_components_quiz_cart_upsell_wrapper__WEBPACK_IMPORTED_MODULE_21__["default"]);
}
if (!customElements.get('quiz-container')) {
  customElements.define('quiz-container', _quiz_components_quiz_container__WEBPACK_IMPORTED_MODULE_0__["default"]);
}
if (!customElements.get('new-product')) {
  customElements.define('new-product', _quiz_components_new_product__WEBPACK_IMPORTED_MODULE_17__["default"]);
}
if (!customElements.get('quiz-progress-bar')) {
  customElements.define('quiz-progress-bar', _quiz_components_quiz_progress_bar__WEBPACK_IMPORTED_MODULE_1__["default"]);
}
if (!customElements.get('quiz-footer')) {
  customElements.define('quiz-footer', _quiz_components_quiz_footer__WEBPACK_IMPORTED_MODULE_2__["default"]);
}
if (!customElements.get('empty-text-modal')) {
  customElements.define('empty-text-modal', _quiz_components_empty_text_modal__WEBPACK_IMPORTED_MODULE_3__["default"]);
}
if (!customElements.get('custom-input-text')) {
  customElements.define('custom-input-text', _quiz_components_custom_input_text__WEBPACK_IMPORTED_MODULE_4__["default"]);
}
if (!customElements.get('custom-input-number')) {
  customElements.define('custom-input-number', _quiz_components_custom_input_number__WEBPACK_IMPORTED_MODULE_5__["default"]);
}
if (!customElements.get('custom-input-range')) {
  customElements.define('custom-input-range', _quiz_components_custom_input_range__WEBPACK_IMPORTED_MODULE_6__["default"]);
}
if (!customElements.get('custom-input-checkbox')) {
  customElements.define('custom-input-checkbox', _quiz_components_custom_input_checkbox__WEBPACK_IMPORTED_MODULE_7__["default"]);
}
if (!customElements.get('date-step-input')) {
  customElements.define('date-step-input', _quiz_components_date_step_input__WEBPACK_IMPORTED_MODULE_8__["default"]);
}
if (!customElements.get('custom-input-radio')) {
  customElements.define('custom-input-radio', _quiz_components_custom_input_radio__WEBPACK_IMPORTED_MODULE_9__["default"]);
}
if (!customElements.get('custom-form')) {
  customElements.define('custom-form', _quiz_components_custom_form__WEBPACK_IMPORTED_MODULE_10__["default"]);
}
if (!customElements.get('custom-dropdown')) {
  customElements.define('custom-dropdown', _quiz_components_custom_dropdown__WEBPACK_IMPORTED_MODULE_11__["default"]);
}
if (!customElements.get('custom-review-slider')) {
  customElements.define('custom-review-slider', _quiz_components_custom_review_slider__WEBPACK_IMPORTED_MODULE_12__["default"]);
}
if (!customElements.get('custom-product-output')) {
  customElements.define('custom-product-output', _quiz_components_custom_product_output__WEBPACK_IMPORTED_MODULE_13__["default"]);
}
if (!customElements.get('quiz-restart-banner')) {
  customElements.define('quiz-restart-banner', _quiz_components_quiz_restart_banner__WEBPACK_IMPORTED_MODULE_15__["default"]);
}
if (!customElements.get('quiz-result-page')) {
  customElements.define('quiz-result-page', _quiz_components_quiz_result_page__WEBPACK_IMPORTED_MODULE_14__["default"]);
}
if (!customElements.get('custom-product-loader')) {
  customElements.define('custom-product-loader', _quiz_components_custom_product_loader__WEBPACK_IMPORTED_MODULE_16__["default"]);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/quiz.js"));
/******/ }
]);